<template>
  <div class="s1-main c1-settings-page" @click="c1TopTab = null">

    <!-- TOAST -->
    <transition name="sg1-toast-fade">
      <div v-if="s1Toast" class="sg1-toast" :style="{ background: s1Toast.color }">{{ s1Toast.msg }}</div>
    </transition>

    <div class="c1-sticky-top">
    <!-- TOP BAR -->
    <div class="c1-tib" @click="s1SlideOpen = null">
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': s1PanelActiveContent === 'viki' }"
          @click.stop="s1SelectPanel('viki')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
          Settings
        </div>
      </div>
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" :class="{ on: $route.path === '/brokers1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" :class="{ on: $route.path === '/security1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" :class="{ on: $route.path === '/quiz1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" :class="{ on: $route.path === '/instruction1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" :class="{ on: $route.path === '/settings1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" :class="{ on: $route.path === '/profile1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- TOP-STRIP TABS -->
    <div class="c1-ts-wrap" @click.stop>
      <!-- Category tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'category'}" @click.stop="c1TopTab = c1TopTab === 'category' ? null : 'category'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
        <span>Category</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='category' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Category dropdown -->
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'category'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-opts" style="padding:10px 14px;flex-wrap:wrap;gap:6px;display:flex;">
            <div v-for="cat in s1Categories" :key="cat.key" class="s1-fp-opt" :class="{ on: s1ActiveCat === cat.key }" @click="s1SetCat(cat.key); c1TopTab = null">{{ cat.label }}</div>
          </div>
        </div>
      </transition>
    </div>

    <!-- PANEL BACKDROP -->
    <transition name="c1-bd-fade">
      <div v-if="s1SlideOpen" class="c1-panel-backdrop" @click.stop="s1SlideOpen = null"></div>
    </transition>

    <!-- UNIFIED PANEL -->
    <div class="c1-panel" :class="{ 'c1-panel--open': s1PanelIsOpen }" @click.capture="s1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': s1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">
          <!-- User strip -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- Timezone bar -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="s1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- Panels mode -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;flex-shrink:0"><line x1="21" y1="4" x2="14" y2="4"/><line x1="10" y1="4" x2="3" y2="4"/><line x1="21" y1="12" x2="12" y2="12"/><line x1="8" y1="12" x2="3" y2="12"/><line x1="21" y1="20" x2="16" y2="20"/><line x1="12" y1="20" x2="3" y2="20"/><circle cx="12" cy="4" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="14" cy="20" r="2"/></svg>
              Filters
            </div>
            <div class="c1-psel-sub" :class="{ on: s1PanelActiveContent === 'filters' }" @click.stop="s1SelectPanel('filters')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Category</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div><!-- end v-else panels -->
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="s1SlideOpen = 'nav'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ s1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="s1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">

            <!-- FILTERS CONTENT -->
            <template v-if="s1PanelActiveContent === 'filters'">
              <div class="c1-fp-group">
                <div class="c1-fp-lbl">Category</div>
                <div class="c1-fp-opts">
                  <div v-for="cat in s1Categories" :key="cat.key" class="s1-fp-opt" :class="{ on: s1ActiveCat === cat.key }" @click="s1SetCat(cat.key)">{{ cat.label }}</div>
                </div>
              </div>
            </template>

          </div>
        </div>
      </div>
    </div>


    <!-- ═══════════════════════════════════════════════════════
         DRAWERS (right-slide overlays)
    ════════════════════════════════════════════════════════════ -->

    <!-- ADD USER DRAWER -->
    <transition name="s1-drawer">
      <div v-if="s1AddUserOpen" class="s1-drawer-wrap" @click.self="s1AddUserOpen = false">
        <div class="s1-drawer">
          <div class="s1-drawer-head">
            <svg viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>
            <div class="s1-drawer-title">{{ s1EditUser ? 'Edit User' : 'Add User' }}</div>
            <button class="s1-drawer-close" @click="s1AddUserOpen = false">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="s1-drawer-body">
            <div class="s1-form-row">
              <label class="s1-form-lbl">First Name</label>
              <input class="s1-form-input" v-model.trim="s1UserForm.first_name" placeholder="First name" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Last Name</label>
              <input class="s1-form-input" v-model.trim="s1UserForm.last_name" placeholder="Last name" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Email</label>
              <input class="s1-form-input" v-model.trim="s1UserForm.email" placeholder="user@gnm.com" type="email" />
            </div>
            <div class="s1-form-row" v-if="!s1EditUser">
              <label class="s1-form-lbl">Password</label>
              <input class="s1-form-input" v-model="s1UserForm.password" placeholder="Minimum 8 characters" type="password" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Role</label>
              <select class="s1-form-select" v-model.number="s1UserForm.role">
                <option :value="1">Admin</option>
                <option :value="2">VP Sales</option>
                <option :value="3">Manager</option>
                <option :value="4">Agent</option>
                <option :value="5">Chat Agent</option>
              </select>
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Team</label>
              <input class="s1-form-input" v-model.trim="s1UserForm.team" placeholder="e.g. Retention, Sales A" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Extension</label>
              <input class="s1-form-input" v-model.trim="s1UserForm.extension" placeholder="e.g. 201" />
            </div>
            <div v-if="s1UserFormError" class="s1-form-err">{{ s1UserFormError }}</div>
            <div class="s1-form-actions">
              <button class="s1-btn-ghost" @click="s1AddUserOpen = false">Cancel</button>
              <button class="s1-btn-primary" @click="s1SubmitUser" :disabled="s1UserSaving">
                {{ s1UserSaving ? 'Saving…' : (s1EditUser ? 'Update User' : 'Create User') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- ADD BROKER DRAWER -->
    <transition name="s1-drawer">
      <div v-if="s1AddBrokerOpen" class="s1-drawer-wrap" @click.self="s1AddBrokerOpen = false">
        <div class="s1-drawer">
          <div class="s1-drawer-head">
            <svg viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
            <div class="s1-drawer-title">{{ s1EditBroker ? 'Edit Broker' : 'Add Broker' }}</div>
            <button class="s1-drawer-close" @click="s1AddBrokerOpen = false">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="s1-drawer-body">
            <div class="s1-form-row">
              <label class="s1-form-lbl">Broker Name</label>
              <input class="s1-form-input" v-model.trim="s1BrokerForm.name" placeholder="e.g. TradeMax" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">CPA ($)</label>
              <input class="s1-form-input" v-model.number="s1BrokerForm.cpa" placeholder="e.g. 500" type="number" min="0" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Deposit Methods</label>
              <input class="s1-form-input" v-model.trim="s1BrokerForm.deposit_methods" placeholder="Card, Wire, Crypto" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Contact Email</label>
              <input class="s1-form-input" v-model.trim="s1BrokerForm.contact_email" placeholder="contact@broker.com" type="email" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Country</label>
              <input class="s1-form-input" v-model.trim="s1BrokerForm.country" placeholder="e.g. UK, IL, AU" />
            </div>
            <div class="s1-form-row s1-form-row-toggle">
              <label class="s1-form-lbl">Active</label>
              <div class="s1-toggle" :class="{ on: s1BrokerForm.active }" @click="s1BrokerForm.active = !s1BrokerForm.active">
                <div class="s1-toggle-dot"></div>
              </div>
            </div>
            <div v-if="s1BrokerFormError" class="s1-form-err">{{ s1BrokerFormError }}</div>
            <div class="s1-form-actions">
              <button class="s1-btn-ghost" @click="s1AddBrokerOpen = false">Cancel</button>
              <button class="s1-btn-primary" @click="s1SubmitBroker" :disabled="s1BrokerSaving">
                {{ s1BrokerSaving ? 'Saving…' : (s1EditBroker ? 'Update Broker' : 'Create Broker') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- ADD CAMPAIGN DRAWER -->
    <transition name="s1-drawer">
      <div v-if="s1AddCampaignOpen" class="s1-drawer-wrap" @click.self="s1AddCampaignOpen = false">
        <div class="s1-drawer">
          <div class="s1-drawer-head">
            <svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <div class="s1-drawer-title">{{ s1EditCampaign ? 'Edit Campaign' : 'Add Campaign' }}</div>
            <button class="s1-drawer-close" @click="s1AddCampaignOpen = false">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="s1-drawer-body">
            <div class="s1-form-row">
              <label class="s1-form-lbl">Campaign Name</label>
              <input class="s1-form-input" v-model.trim="s1CampaignForm.name" placeholder="e.g. Google Q1 2024" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Source</label>
              <select class="s1-form-select" v-model="s1CampaignForm.source">
                <option value="google">Google Ads</option>
                <option value="facebook">Facebook</option>
                <option value="bing">Bing</option>
                <option value="tiktok">TikTok</option>
                <option value="organic">Organic</option>
                <option value="referral">Referral</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Budget ($)</label>
              <input class="s1-form-input" v-model.number="s1CampaignForm.budget" placeholder="e.g. 10000" type="number" min="0" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Cost Per Lead ($)</label>
              <input class="s1-form-input" v-model.number="s1CampaignForm.cpl" placeholder="e.g. 25" type="number" min="0" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Start Date</label>
              <input class="s1-form-input" v-model="s1CampaignForm.start_date" type="date" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">End Date</label>
              <input class="s1-form-input" v-model="s1CampaignForm.end_date" type="date" />
            </div>
            <div class="s1-form-row s1-form-row-toggle">
              <label class="s1-form-lbl">Active</label>
              <div class="s1-toggle" :class="{ on: s1CampaignForm.active }" @click="s1CampaignForm.active = !s1CampaignForm.active">
                <div class="s1-toggle-dot"></div>
              </div>
            </div>
            <div v-if="s1CampaignFormError" class="s1-form-err">{{ s1CampaignFormError }}</div>
            <div class="s1-form-actions">
              <button class="s1-btn-ghost" @click="s1AddCampaignOpen = false">Cancel</button>
              <button class="s1-btn-primary" @click="s1SubmitCampaign" :disabled="s1CampaignSaving">
                {{ s1CampaignSaving ? 'Saving…' : (s1EditCampaign ? 'Update' : 'Create Campaign') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- GAMES PERMISSIONS DRAWER -->
    <transition name="s1-drawer">
      <div v-if="s1GamesDrawerOpen" class="s1-drawer-wrap s1-drawer-wrap-wide" @click.self="s1GamesDrawerOpen = false">
        <div class="s1-drawer s1-drawer-wide">
          <div class="s1-drawer-head">
            <svg viewBox="0 0 24 24"><line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/><circle cx="15" cy="13" r="1"/><circle cx="18" cy="11" r="1"/><rect x="2" y="6" width="20" height="12" rx="2"/></svg>
            <div class="s1-drawer-title">Games Permission Matrix</div>
            <button class="s1-drawer-close" @click="s1GamesDrawerOpen = false">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="s1-drawer-body">
            <div class="s1-perm-info-bar">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Toggle cells to grant or revoke access. Changes save instantly.
            </div>
            <div v-if="s1GamesLoading" class="s1-loading-row">
              <div class="s1-spinner"></div>
              <span>Loading permissions…</span>
            </div>
            <div v-else class="s1-perm-table-wrap">
              <table class="s1-perm-table">
                <thead>
                  <tr>
                    <th class="s1-pt-user-col">User</th>
                    <th v-for="game in s1Games" :key="game.id" class="s1-pt-game-col">
                      <div class="s1-pt-game-name">{{ game.name }}</div>
                    </th>
                    <th class="s1-pt-game-col">Daily Limit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in s1PermUsers" :key="user.id">
                    <td class="s1-pt-user-cell">
                      <div class="s1-pt-user-av">{{ s1UserIni(user) }}</div>
                      <div class="s1-pt-user-info">
                        <span class="s1-pt-user-name">{{ user.first_name }} {{ user.last_name }}</span>
                        <span class="s1-pt-user-role">{{ s1RoleMap[user.role] || 'Agent' }}</span>
                      </div>
                    </td>
                    <td v-for="game in s1Games" :key="game.id" class="s1-pt-toggle-cell">
                      <div class="s1-perm-toggle" :class="{ on: s1HasPerm(user.id, game.id) }" @click="s1TogglePerm(user.id, game.id)">
                        <div class="s1-perm-dot"></div>
                      </div>
                    </td>
                    <td class="s1-pt-toggle-cell">
                      <div class="s1-pt-limit-wrap">
                        <input class="s1-pt-limit-input" type="number" min="0" max="480"
                          :value="s1GameLimits[user.id] || 60"
                          @change="s1SetGameLimit(user.id, $event.target.value)" />
                        <span class="s1-pt-limit-unit">min</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!s1PermUsers.length">
                    <td :colspan="s1Games.length + 2" class="s1-pt-empty">No users found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- DEPOSIT GOAL PER-AGENT DRAWER -->
    <transition name="s1-drawer">
      <div v-if="s1GoalAgentOpen" class="s1-drawer-wrap" @click.self="s1GoalAgentOpen = false">
        <div class="s1-drawer">
          <div class="s1-drawer-head">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
            <div class="s1-drawer-title">Per-Agent Goals</div>
            <button class="s1-drawer-close" @click="s1GoalAgentOpen = false">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="s1-drawer-body">
            <div class="s1-perm-info-bar">Set individual daily deposit targets per agent. Leave blank to use global default.</div>
            <div v-if="s1GoalUsersLoading" class="s1-loading-row">
              <div class="s1-spinner"></div><span>Loading agents…</span>
            </div>
            <div v-else class="s1-agent-goal-list">
              <div v-for="user in s1GoalUsers" :key="user.id" class="s1-agent-goal-row">
                <div class="s1-pt-user-av">{{ s1UserIni(user) }}</div>
                <div class="s1-agent-goal-name">{{ user.first_name }} {{ user.last_name }}</div>
                <div class="s1-agent-goal-ctrl">
                  <input class="s1-pt-limit-input s1-pt-limit-wide" type="number" min="0"
                    :placeholder="s1Goals.daily_target || 10"
                    :value="s1AgentGoals[user.id] || ''"
                    @change="s1SetAgentGoal(user.id, $event.target.value)" />
                  <span class="s1-pt-limit-unit">dep/day</span>
                </div>
              </div>
              <div v-if="!s1GoalUsers.length" class="s1-pt-empty">No agents found</div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- SYSTEM LOG DRAWER -->
    <transition name="s1-drawer">
      <div v-if="s1LogDrawerOpen" class="s1-drawer-wrap s1-drawer-wrap-wide" @click.self="s1LogDrawerOpen = false">
        <div class="s1-drawer s1-drawer-wide">
          <div class="s1-drawer-head">
            <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
            <div class="s1-drawer-title">System Activity Log</div>
            <button class="s1-drawer-close" @click="s1LogDrawerOpen = false">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="s1-drawer-body">
            <div class="s1-log-toolbar">
              <input class="s1-log-search" v-model.trim="s1LogSearch" placeholder="Search logs…" />
              <select class="s1-log-filter-sel" v-model="s1LogTypeFilter">
                <option value="">All types</option>
                <option value="login">Login</option>
                <option value="user">User</option>
                <option value="settings">Settings</option>
                <option value="broker">Broker</option>
                <option value="deposit">Deposit</option>
                <option value="error">Error</option>
              </select>
              <button class="s1-btn-ghost s1-log-refresh-btn" @click="s1LoadLogs" :disabled="s1LogsLoading">
                <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
              </button>
            </div>
            <div v-if="s1LogsLoading" class="s1-loading-row">
              <div class="s1-spinner"></div><span>Loading logs…</span>
            </div>
            <div v-else class="s1-log-list">
              <div v-for="log in s1FilteredLogs" :key="log.id" class="s1-log-row" :class="'s1-log-' + (log.type || 'info')">
                <div class="s1-log-dot"></div>
                <div class="s1-log-body">
                  <div class="s1-log-msg">{{ log.message }}</div>
                  <div class="s1-log-meta">
                    <span class="s1-log-type-tag">{{ log.type || 'info' }}</span>
                    <span class="s1-log-user">{{ log.user_name || 'System' }}</span>
                    <span class="s1-log-time">{{ s1FmtLogTime(log.created_at) }}</span>
                  </div>
                </div>
              </div>
              <div v-if="!s1FilteredLogs.length" class="s1-pt-empty">No log entries found</div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- ═══════════════════════════════════════════════════════
         MAIN CONTENT
    ════════════════════════════════════════════════════════════ -->
    <div class="s1-content">

      <!-- PAGE HEADER -->
      <div class="s1-page-hdr">
        <div class="s1-page-hdr-icon">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
        </div>
        <div>
          <div class="s1-page-title">Settings</div>
          <div class="s1-page-sub">System configuration &amp; administration</div>
        </div>
      </div>

      <!-- SAVE INDICATOR -->
      <transition name="s1-saved">
        <div v-if="s1SavedVisible" class="s1-saved-toast">
          <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
          Saved
        </div>
      </transition>

      <!-- SETTINGS CARD GRID -->
      <div class="s1-card-grid">
        <div v-for="cat in s1Categories.filter(c => c.key !== 'all')" :key="cat.key"
          class="s1-cat-card"
          :class="{ 'active': s1ActiveSection === cat.key }"
          @click="s1OpenSection(cat.key)">
          <div class="s1-cat-card-icon" :style="{ background: cat.color + '20', color: cat.color }">
            <svg viewBox="0 0 24 24" v-html="cat.iconPath"></svg>
          </div>
          <div class="s1-cat-card-label">{{ cat.label }}</div>
          <div class="s1-cat-card-desc">{{ cat.desc }}</div>
          <svg class="s1-cat-card-arrow" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
        </div>
      </div>

      <!-- ───────────────────────────────────────────────────────────
           SECTION PANELS (expand below grid when card clicked)
      ──────────────────────────────────────────────────────────────── -->

      <!-- ═══ 1. USERS & ROLES ═══ -->
      <div v-if="s1ActiveSection === 'users'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Users &amp; Roles</div>
          <div class="s1-section-sub">Manage team members, roles, and access levels</div>
          <button class="s1-btn-primary s1-section-action" @click="s1OpenAddUser">
            <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add User
          </button>
        </div>

        <div v-if="!s1AdminOnly" class="s1-admin-gate">
          <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Admin access required to manage users
        </div>

        <template v-else>
          <!-- Search -->
          <div class="s1-table-toolbar">
            <div class="s1-search-wrap">
              <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input class="s1-search-input" v-model.trim="s1UserSearch" placeholder="Search by name or email…" />
            </div>
            <select class="s1-tbar-sel" v-model="s1UserRoleFilter">
              <option value="">All roles</option>
              <option value="1">Admin</option>
              <option value="2">VP Sales</option>
              <option value="3">Manager</option>
              <option value="4">Agent</option>
              <option value="5">Chat Agent</option>
            </select>
          </div>

          <!-- Users loading -->
          <div v-if="s1UsersLoading" class="s1-loading-row">
            <div class="s1-spinner"></div><span>Loading users…</span>
          </div>

          <!-- Users table -->
          <div v-else class="s1-table-wrap">
            <table class="s1-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Team</th>
                  <th>Active</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in s1FilteredUsers" :key="user.id" class="s1-table-row" @click="s1OpenEditUser(user)">
                  <td>
                    <div class="s1-user-cell">
                      <div class="s1-user-av" :style="{ background: s1AvatarColor(user.id) }">{{ s1UserIni(user) }}</div>
                      <div class="s1-user-name-wrap">
                        <div class="s1-user-full-name">{{ user.first_name }} {{ user.last_name }}</div>
                        <div class="s1-user-ext" v-if="user.extension">ext. {{ user.extension }}</div>
                      </div>
                    </div>
                  </td>
                  <td class="s1-td-muted">{{ user.email }}</td>
                  <td>
                    <span class="s1-role-badge" :class="'s1-role-' + user.role">{{ s1RoleMap[user.role] || 'Agent' }}</span>
                  </td>
                  <td class="s1-td-muted">{{ user.team || '—' }}</td>
                  <td @click.stop>
                    <div class="s1-toggle s1-toggle-sm" :class="{ on: user.active !== false }" @click="s1ToggleUserActive(user)">
                      <div class="s1-toggle-dot"></div>
                    </div>
                  </td>
                  <td @click.stop>
                    <button class="s1-row-edit-btn" @click="s1OpenEditUser(user)">
                      <svg viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    </button>
                  </td>
                </tr>
                <tr v-if="!s1FilteredUsers.length">
                  <td colspan="6" class="s1-pt-empty">No users found</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Role reference -->
          <div class="s1-subsection-hdr">Role Definitions</div>
          <div class="s1-role-grid">
            <div v-for="(label, id) in s1RoleMap" :key="id" class="s1-role-card">
              <span class="s1-role-badge" :class="'s1-role-' + id">{{ label }}</span>
              <div class="s1-role-desc">{{ s1RoleDesc[id] || '' }}</div>
            </div>
          </div>
        </template>
      </div>

      <!-- ═══ 2. BROKERS ═══ -->
      <div v-if="s1ActiveSection === 'brokers'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Brokers</div>
          <div class="s1-section-sub">Manage broker accounts, CPA rates, and deposit methods</div>
          <button class="s1-btn-primary s1-section-action" @click="s1OpenAddBroker" v-if="s1AdminOnly">
            <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add Broker
          </button>
        </div>

        <div v-if="s1BrokersLoading" class="s1-loading-row">
          <div class="s1-spinner"></div><span>Loading brokers…</span>
        </div>

        <div v-else class="s1-table-wrap">
          <table class="s1-table">
            <thead>
              <tr>
                <th>Broker</th>
                <th>CPA</th>
                <th>Deposit Methods</th>
                <th>Country</th>
                <th>Active</th>
                <th v-if="s1AdminOnly"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="broker in s1Brokers" :key="broker.id" class="s1-table-row">
                <td>
                  <div class="s1-broker-cell">
                    <div class="s1-broker-av">{{ (broker.name || 'B')[0].toUpperCase() }}</div>
                    <span class="s1-broker-name">{{ broker.name }}</span>
                  </div>
                </td>
                <td>
                  <span class="s1-cpa-badge">${{ broker.cpa || 0 }}</span>
                </td>
                <td class="s1-td-muted">{{ broker.deposit_methods || '—' }}</td>
                <td class="s1-td-muted">{{ broker.country || '—' }}</td>
                <td>
                  <div class="s1-toggle s1-toggle-sm" :class="{ on: broker.active !== false }" @click="s1AdminOnly && s1ToggleBrokerActive(broker)">
                    <div class="s1-toggle-dot"></div>
                  </div>
                </td>
                <td v-if="s1AdminOnly">
                  <button class="s1-row-edit-btn" @click="s1OpenEditBroker(broker)">
                    <svg viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </button>
                </td>
              </tr>
              <tr v-if="!s1Brokers.length">
                <td :colspan="s1AdminOnly ? 6 : 5" class="s1-pt-empty">No brokers configured</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ═══ 3. CAMPAIGNS ═══ -->
      <div v-if="s1ActiveSection === 'campaigns'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Campaigns</div>
          <div class="s1-section-sub">Track marketing campaigns, budgets, and cost per lead</div>
          <button class="s1-btn-primary s1-section-action" @click="s1OpenAddCampaign" v-if="s1AdminOnly">
            <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add Campaign
          </button>
        </div>

        <!-- CPL by source summary -->
        <div class="s1-subsection-hdr">Cost Per Lead by Source</div>
        <div class="s1-cpl-grid">
          <div v-for="src in s1CplSources" :key="src.key" class="s1-cpl-card">
            <div class="s1-cpl-source">{{ src.label }}</div>
            <div class="s1-cpl-val-wrap">
              <span class="s1-cpl-prefix">$</span>
              <input class="s1-cpl-input" type="number" min="0" v-model.number="src.cpl" @change="s1SaveCplSource(src)" />
            </div>
            <div class="s1-cpl-unit">per lead</div>
          </div>
        </div>

        <div class="s1-subsection-hdr" style="margin-top:24px">Call Cost Rate</div>
        <div class="s1-row" style="max-width:420px">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Cost per minute (calls)</div>
            <div class="s1-row-desc">Used in call cost reports</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-num-wrap">
              <span class="s1-num-prefix">$</span>
              <input class="s1-num-input s1-num-wide" type="number" min="0" step="0.01" v-model.number="s1Settings.callCostPerMin" @change="s1AutoSave('callCostPerMin')" />
              <span class="s1-num-unit">/min</span>
            </div>
          </div>
        </div>

        <div class="s1-subsection-hdr" style="margin-top:24px">Active Campaigns</div>
        <div v-if="s1CampaignsLoading" class="s1-loading-row">
          <div class="s1-spinner"></div><span>Loading campaigns…</span>
        </div>
        <div v-else class="s1-table-wrap">
          <table class="s1-table">
            <thead>
              <tr>
                <th>Campaign</th>
                <th>Source</th>
                <th>Budget</th>
                <th>CPL</th>
                <th>Dates</th>
                <th>Active</th>
                <th v-if="s1AdminOnly"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="camp in s1Campaigns" :key="camp.id" class="s1-table-row">
                <td class="s1-td-bold">{{ camp.name }}</td>
                <td>
                  <span class="s1-source-badge" :class="'s1-source-' + camp.source">{{ s1SourceLabel(camp.source) }}</span>
                </td>
                <td class="s1-td-muted">${{ (camp.budget || 0).toLocaleString() }}</td>
                <td class="s1-td-muted">${{ camp.cpl || '—' }}</td>
                <td class="s1-td-muted s1-td-sm">{{ camp.start_date || '—' }} → {{ camp.end_date || '∞' }}</td>
                <td>
                  <div class="s1-toggle s1-toggle-sm" :class="{ on: camp.active !== false }">
                    <div class="s1-toggle-dot"></div>
                  </div>
                </td>
                <td v-if="s1AdminOnly">
                  <button class="s1-row-edit-btn" @click="s1OpenEditCampaign(camp)">
                    <svg viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </button>
                </td>
              </tr>
              <tr v-if="!s1Campaigns.length">
                <td :colspan="s1AdminOnly ? 7 : 6" class="s1-pt-empty">No campaigns yet</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ═══ 4. GAMES PERMISSIONS ═══ -->
      <div v-if="s1ActiveSection === 'games'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Games Permissions</div>
          <div class="s1-section-sub">Control which agents can access each game — Tetris, Snake, Pong, TicTacToe, Memory</div>
          <button class="s1-btn-primary s1-section-action" @click="s1OpenGamesMatrix">
            <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
            Open Full Matrix
          </button>
        </div>
        <div v-if="!s1AdminOnly" class="s1-admin-gate">
          <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Admin access required
        </div>
        <template v-else>
          <div class="s1-games-summary-grid">
            <div v-for="game in s1Games" :key="game.id" class="s1-game-summary-card">
              <div class="s1-game-ico">
                <svg viewBox="0 0 24 24"><line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/><circle cx="15" cy="13" r="1"/><circle cx="18" cy="11" r="1"/><rect x="2" y="6" width="20" height="12" rx="2"/></svg>
              </div>
              <div class="s1-game-name">{{ game.name }}</div>
              <div class="s1-game-stat">{{ s1GameEnabledCount(game.id) }} / {{ s1PermUsers.length }} users</div>
              <div class="s1-game-progress">
                <div class="s1-game-progress-bar" :style="{ width: s1GameEnabledPct(game.id) + '%' }"></div>
              </div>
            </div>
          </div>

          <!-- Inline permissions table -->
          <div class="s1-subsection-hdr" style="margin-top:16px">
            Permission Matrix
            <div class="s1-search-wrap" style="flex:1;max-width:220px;margin-left:auto">
              <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input class="s1-search-input" v-model.trim="s1GamesSearchName" placeholder="Filter users..." />
            </div>
          </div>
          <div v-if="s1GamesLoading" class="s1-loading-row"><div class="s1-spinner"></div><span>Loading permissions...</span></div>
          <div v-else class="s1-table-wrap" style="margin:0 0 8px">
            <table class="s1-perm-table">
              <thead>
                <tr>
                  <th class="s1-pt-user-col">User</th>
                  <th class="s1-pt-game-col" style="min-width:60px">Role</th>
                  <th v-for="game in s1Games" :key="game.id" class="s1-pt-game-col">
                    <div class="s1-pt-game-name">{{ game.name }}</div>
                  </th>
                  <th class="s1-pt-game-col" style="min-width:110px">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in s1FilteredPermUsers" :key="user.id || user.user_id">
                  <td class="s1-pt-user-cell">
                    <div class="s1-pt-user-av" :style="{ background: s1AvatarColor(user.id || user.user_id) }">{{ s1UserIni(user) }}</div>
                    <div class="s1-pt-user-info">
                      <span class="s1-pt-user-name">{{ user.first_name }} {{ user.last_name }}</span>
                    </div>
                  </td>
                  <td class="s1-pt-toggle-cell">
                    <span class="s1-role-badge" :class="'s1-role-' + (user.role || 4)">{{ s1RoleMap[user.role] || 'Agent' }}</span>
                  </td>
                  <td v-for="game in s1Games" :key="game.id" class="s1-pt-toggle-cell">
                    <div class="s1-perm-toggle" :class="{ on: s1HasPerm(user.id || user.user_id, game.id) }" @click="s1TogglePerm(user.id || user.user_id, game.id)">
                      <div class="s1-perm-dot"></div>
                    </div>
                  </td>
                  <td class="s1-pt-toggle-cell">
                    <div class="s1-games-action-btns">
                      <button class="s1-games-grant-btn" @click="s1GrantAllGames(user.id || user.user_id)" title="Grant All">
                        <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                        All
                      </button>
                      <button class="s1-games-revoke-btn" @click="s1RevokeAllGames(user.id || user.user_id)" title="Revoke All">
                        <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                        None
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!s1FilteredPermUsers.length">
                  <td :colspan="s1Games.length + 3" class="s1-pt-empty">No users found</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="s1-row" style="margin-top:12px">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Global games access</div>
              <div class="s1-row-desc">Master switch — disables all games when off</div>
            </div>
            <div class="s1-row-ctrl">
              <div class="s1-toggle" :class="{ on: s1Settings.gamesEnabled }" @click="s1ToggleSetting('gamesEnabled')">
                <div class="s1-toggle-dot"></div>
              </div>
            </div>
          </div>
          <div class="s1-row">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Default daily limit</div>
              <div class="s1-row-desc">Default minutes per day for new users</div>
            </div>
            <div class="s1-row-ctrl">
              <div class="s1-num-wrap">
                <input class="s1-num-input" type="number" min="0" max="480" v-model.number="s1Settings.gamesDefaultLimit" @change="s1AutoSave('gamesDefaultLimit')" />
                <span class="s1-num-unit">min/day</span>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- ═══ 5. DEPOSIT GOALS ═══ -->
      <div v-if="s1ActiveSection === 'goals'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Deposit Goals</div>
          <div class="s1-section-sub">Set daily, weekly, and monthly deposit targets for the team</div>
        </div>

        <!-- KPI CARDS ROW -->
        <div class="s1-goals-grid">
          <!-- Daily KPI + Input -->
          <div class="s1-goal-card">
            <div class="s1-goal-card-hdr">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              <span>Daily Goal</span>
            </div>
            <div class="s1-goal-kpi-val">{{ s1Goals.daily_target || 0 }}</div>
            <div class="s1-goal-kpi-lbl">Current target</div>
            <div v-if="s1GoalDailyObj" class="s1-goal-kpi-date">Set {{ s1FmtGoalDate(s1GoalDailyObj.created_at) }}</div>
            <div class="s1-goal-input-row">
              <input class="s1-goal-input" type="number" min="0" v-model.number="s1GoalDailyInput" placeholder="New daily goal" />
              <button class="s1-btn-primary s1-goal-save-btn" @click="s1SaveDailyGoal" :disabled="s1GoalSaving">
                {{ s1GoalSaving ? 'Saving...' : 'Save' }}
              </button>
            </div>
            <div class="s1-goal-progress-wrap" v-if="s1Goals.daily_current !== undefined">
              <div class="s1-goal-progress-lbl">
                <span>Today: {{ s1Goals.daily_current }}</span>
                <span>{{ s1GoalPct(s1Goals.daily_current, s1Goals.daily_target) }}%</span>
              </div>
              <div class="s1-goal-bar">
                <div class="s1-goal-bar-fill" :style="{ width: s1GoalPct(s1Goals.daily_current, s1Goals.daily_target) + '%' }"></div>
              </div>
            </div>
          </div>

          <!-- Weekly KPI + Input -->
          <div class="s1-goal-card">
            <div class="s1-goal-card-hdr">
              <svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
              <span>Weekly Goal</span>
            </div>
            <div class="s1-goal-kpi-val s1-goal-kpi-warn">{{ s1Goals.weekly_target || 0 }}</div>
            <div class="s1-goal-kpi-lbl">Current target</div>
            <div v-if="s1GoalWeeklyObj" class="s1-goal-kpi-date">Set {{ s1FmtGoalDate(s1GoalWeeklyObj.created_at) }}</div>
            <div class="s1-goal-input-row">
              <input class="s1-goal-input" type="number" min="0" v-model.number="s1GoalWeeklyInput" placeholder="New weekly goal" />
              <button class="s1-btn-primary s1-goal-save-btn" @click="s1SaveWeeklyGoal" :disabled="s1GoalSaving">
                {{ s1GoalSaving ? 'Saving...' : 'Save' }}
              </button>
            </div>
            <div class="s1-goal-progress-wrap" v-if="s1Goals.weekly_current !== undefined">
              <div class="s1-goal-progress-lbl">
                <span>This week: {{ s1Goals.weekly_current }}</span>
                <span>{{ s1GoalPct(s1Goals.weekly_current, s1Goals.weekly_target) }}%</span>
              </div>
              <div class="s1-goal-bar">
                <div class="s1-goal-bar-fill s1-goal-bar-week" :style="{ width: s1GoalPct(s1Goals.weekly_current, s1Goals.weekly_target) + '%' }"></div>
              </div>
            </div>
          </div>

          <!-- Monthly KPI + Input -->
          <div class="s1-goal-card">
            <div class="s1-goal-card-hdr">
              <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span>Monthly Goal</span>
            </div>
            <div class="s1-goal-kpi-val s1-goal-kpi-green">{{ s1Goals.monthly_target || 0 }}</div>
            <div class="s1-goal-kpi-lbl">Current target</div>
            <div v-if="s1GoalMonthlyObj" class="s1-goal-kpi-date">Set {{ s1FmtGoalDate(s1GoalMonthlyObj.created_at) }}</div>
            <div class="s1-goal-input-row">
              <input class="s1-goal-input" type="number" min="0" v-model.number="s1GoalMonthlyInput" placeholder="New monthly goal" />
              <button class="s1-btn-primary s1-goal-save-btn" @click="s1SaveMonthlyGoal" :disabled="s1GoalSaving">
                {{ s1GoalSaving ? 'Saving...' : 'Save' }}
              </button>
            </div>
            <div class="s1-goal-progress-wrap" v-if="s1Goals.monthly_current !== undefined">
              <div class="s1-goal-progress-lbl">
                <span>This month: {{ s1Goals.monthly_current }}</span>
                <span>{{ s1GoalPct(s1Goals.monthly_current, s1Goals.monthly_target) }}%</span>
              </div>
              <div class="s1-goal-bar">
                <div class="s1-goal-bar-fill s1-goal-bar-month" :style="{ width: s1GoalPct(s1Goals.monthly_current, s1Goals.monthly_target) + '%' }"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- GOAL HISTORY TABLE -->
        <div class="s1-subsection-hdr" style="margin-top:28px">Goal History</div>
        <div v-if="s1GoalHistoryLoading" class="s1-loading-row"><div class="s1-spinner"></div><span>Loading history...</span></div>
        <div v-else-if="s1GoalHistory.length" class="s1-table-wrap" style="margin:0 16px 16px">
          <table class="s1-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Amount</th>
                <th>Set By</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(h, idx) in s1GoalHistory" :key="idx" class="s1-table-row">
                <td><span class="s1-role-badge" :class="h.goal_type === 'DAILY' ? 's1-role-4' : h.goal_type === 'WEEKLY' ? 's1-role-5' : 's1-role-2'">{{ h.goal_type }}</span></td>
                <td class="s1-td-bold">{{ h.goal_count }}</td>
                <td class="s1-td-muted">{{ h.user_name || 'Admin' }}</td>
                <td class="s1-td-muted s1-td-sm">{{ s1FmtGoalDate(h.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="s1-pt-empty" style="padding:16px">No goal history available</div>

        <!-- PER-AGENT GOALS -->
        <div class="s1-subsection-hdr" style="margin-top:12px">
          Per-Agent Goals
          <button class="s1-subsec-btn" @click="s1GoalAgentOpen = true; s1LoadGoalUsers()">
            <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
            Manage
          </button>
        </div>
        <div class="s1-agent-goals-preview">
          <div v-for="(goal, uid) in s1AgentGoals" :key="uid" class="s1-agent-goal-chip">
            <span class="s1-ag-name">{{ s1UserNameById(uid) }}</span>
            <span class="s1-ag-val">{{ goal }} dep/day</span>
          </div>
          <div v-if="!Object.keys(s1AgentGoals).length" class="s1-td-muted" style="font-size:12px;padding:12px 0">No individual goals set — all agents use global daily target</div>
        </div>

        <div class="s1-row" style="margin-top:20px">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Goal alerts via Viki</div>
            <div class="s1-row-desc">Send Viki notification when goal is reached</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.goalAlerts }" @click="s1ToggleSetting('goalAlerts')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Warn when below target</div>
            <div class="s1-row-desc">Alert if daily pace is behind by end of shift</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.goalWarnBehind }" @click="s1ToggleSetting('goalWarnBehind')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- ═══ 6. SYSTEM LOGS ═══ -->
      <div v-if="s1ActiveSection === 'logs'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">System Logs</div>
          <div class="s1-section-sub">Paginated system activity and client cron logs from the backend</div>
          <button class="s1-btn-ghost s1-section-action" @click="s1RefreshAllLogs">
            <svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
            Refresh All
          </button>
        </div>
        <div v-if="!s1AdminOnly" class="s1-admin-gate">
          <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Admin access required
        </div>
        <template v-else>
          <!-- SUB-TABS -->
          <div class="s1-log-subtabs">
            <div class="s1-log-subtab" :class="{ active: s1LogSubTab === 'system' }" @click="s1LogSubTab = 'system'">
              <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
              System Log
            </div>
            <div class="s1-log-subtab" :class="{ active: s1LogSubTab === 'client' }" @click="s1LogSubTab = 'client'">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              Client Cron Log
            </div>
            <div class="s1-log-subtab" :class="{ active: s1LogSubTab === 'task' }" @click="s1LogSubTab = 'task'">
              <svg viewBox="0 0 24 24"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
              Task Cron Log
            </div>
          </div>

          <!-- SYSTEM LOG TABLE -->
          <div v-if="s1LogSubTab === 'system'">
            <div class="s1-log-toolbar">
              <div class="s1-log-toolbar-info">Page {{ s1SysLogPage }}</div>
              <button class="s1-btn-ghost s1-log-sort-btn" @click="s1ToggleSysLogSort" style="padding:5px 10px;font-size:11px">
                <svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round"><line x1="12" y1="5" x2="12" y2="19"/><polyline :points="s1SysLogSortOrder === 'asc' ? '19 12 12 19 5 12' : '5 12 12 5 19 12'"/></svg>
                Sort {{ s1SysLogSortOrder === 'asc' ? 'Oldest' : 'Newest' }}
              </button>
              <button class="s1-btn-ghost" @click="s1FetchSysLog" :disabled="s1SysLogLoading" style="padding:5px 10px;font-size:11px">
                <svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
                Refresh
              </button>
            </div>
            <div v-if="s1SysLogLoading" class="s1-loading-row"><div class="s1-spinner"></div><span>Loading system log...</span></div>
            <div v-else class="s1-table-wrap">
              <table class="s1-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Asset</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Updated</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(entry, idx) in s1SysLogData" :key="idx" class="s1-table-row">
                    <td class="s1-td-muted">{{ entry.user_id !== null ? entry.user_id : 'NO-UID' }}</td>
                    <td class="s1-td-muted">{{ entry.asset || '--' }}</td>
                    <td class="s1-td-muted s1-td-sm" style="max-width:300px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ s1TruncateLog(entry.status, 200) }}</td>
                    <td class="s1-td-muted s1-td-sm">{{ s1FmtLogTime(entry.created_at) }}</td>
                    <td class="s1-td-muted s1-td-sm">{{ s1FmtLogTime(entry.updated_at) }}</td>
                  </tr>
                  <tr v-if="!s1SysLogData.length">
                    <td colspan="5" class="s1-pt-empty">No system log entries</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="s1-log-pagination">
              <button class="s1-btn-ghost" :disabled="s1SysLogPage <= 1" @click="s1SysLogPage--; s1FetchSysLog()" style="padding:5px 12px;font-size:11px">Prev</button>
              <span class="s1-log-page-num">Page {{ s1SysLogPage }}</span>
              <button class="s1-btn-ghost" @click="s1SysLogPage++; s1FetchSysLog()" :disabled="s1SysLogData.length < 20" style="padding:5px 12px;font-size:11px">Next</button>
            </div>
          </div>

          <!-- CLIENT CRON LOG TABLE -->
          <div v-if="s1LogSubTab === 'client'">
            <div class="s1-log-toolbar">
              <div class="s1-log-toolbar-info">Page {{ s1ClientLogPage }}</div>
              <button class="s1-btn-ghost" @click="s1FetchClientLog" :disabled="s1ClientLogLoading" style="padding:5px 10px;font-size:11px">
                <svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
                Refresh
              </button>
            </div>
            <div v-if="s1ClientLogLoading" class="s1-loading-row"><div class="s1-spinner"></div><span>Loading client cron log...</span></div>
            <div v-else class="s1-table-wrap">
              <table class="s1-table">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>User</th>
                    <th>Asset</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Updated</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(entry, idx) in s1ClientLogData" :key="idx" class="s1-table-row">
                    <td class="s1-td-muted">{{ entry.client_id != null ? entry.client_id : 'No-CID' }}</td>
                    <td class="s1-td-muted">{{ entry.user_id !== null ? entry.user_id : 'NO-UID' }}</td>
                    <td class="s1-td-muted">{{ entry.asset || '--' }}</td>
                    <td class="s1-td-muted s1-td-sm" style="max-width:300px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ s1TruncateLog(entry.status, 200) }}</td>
                    <td class="s1-td-muted s1-td-sm">{{ s1FmtLogTime(entry.created_at) }}</td>
                    <td class="s1-td-muted s1-td-sm">{{ s1FmtLogTime(entry.updated_at) }}</td>
                  </tr>
                  <tr v-if="!s1ClientLogData.length">
                    <td colspan="6" class="s1-pt-empty">No client cron log entries</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="s1-log-pagination">
              <button class="s1-btn-ghost" :disabled="s1ClientLogPage <= 1" @click="s1ClientLogPage--; s1FetchClientLog()" style="padding:5px 12px;font-size:11px">Prev</button>
              <span class="s1-log-page-num">Page {{ s1ClientLogPage }}</span>
              <button class="s1-btn-ghost" @click="s1ClientLogPage++; s1FetchClientLog()" :disabled="s1ClientLogData.length < 20" style="padding:5px 12px;font-size:11px">Next</button>
            </div>
          </div>

          <!-- TASK CRON LOG TABLE -->
          <div v-if="s1LogSubTab === 'task'">
            <div class="s1-log-toolbar">
              <div class="s1-log-toolbar-info">Page {{ s1TaskLogPage }}</div>
              <button class="s1-btn-ghost" @click="s1FetchTaskLog" :disabled="s1TaskLogLoading" style="padding:5px 10px;font-size:11px">
                <svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
                Refresh
              </button>
            </div>
            <div v-if="s1TaskLogLoading" class="s1-loading-row"><div class="s1-spinner"></div><span>Loading task cron log...</span></div>
            <div v-else class="s1-table-wrap">
              <table class="s1-table">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Task</th>
                    <th>User</th>
                    <th>Asset</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Updated</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(entry, idx) in s1TaskLogData" :key="idx" class="s1-table-row">
                    <td class="s1-td-muted">{{ entry.client_id != null ? entry.client_id : 'NO-CID' }}</td>
                    <td class="s1-td-muted">{{ entry.task_id != null ? entry.task_id : 'NO-TID' }}</td>
                    <td class="s1-td-muted">{{ entry.user_id !== null ? entry.user_id : 'NO-UID' }}</td>
                    <td class="s1-td-muted">{{ entry.asset || '--' }}</td>
                    <td class="s1-td-muted s1-td-sm" style="max-width:250px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ s1TruncateLog(entry.status, 200) }}</td>
                    <td class="s1-td-muted s1-td-sm">{{ s1FmtLogTime(entry.created_at) }}</td>
                    <td class="s1-td-muted s1-td-sm">{{ s1FmtLogTime(entry.updated_at) }}</td>
                  </tr>
                  <tr v-if="!s1TaskLogData.length">
                    <td colspan="7" class="s1-pt-empty">No task cron log entries</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="s1-log-pagination">
              <button class="s1-btn-ghost" :disabled="s1TaskLogPage <= 1" @click="s1TaskLogPage--; s1FetchTaskLog()" style="padding:5px 12px;font-size:11px">Prev</button>
              <span class="s1-log-page-num">Page {{ s1TaskLogPage }}</span>
              <button class="s1-btn-ghost" @click="s1TaskLogPage++; s1FetchTaskLog()" :disabled="s1TaskLogData.length < 20" style="padding:5px 12px;font-size:11px">Next</button>
            </div>
          </div>
        </template>
      </div>

      <!-- ═══ 7. CRM CONFIGURATION ═══ -->
      <div v-if="s1ActiveSection === 'crm'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">CRM Configuration</div>
          <div class="s1-section-sub">Status tags, country tiers, and display settings</div>
        </div>

        <div class="s1-subsection-hdr">Status Tag Colors</div>
        <div class="s1-status-tag-grid">
          <div v-for="tag in s1StatusTags" :key="tag.key" class="s1-status-tag-row">
            <div class="s1-status-tag-dot" :style="{ background: tag.color }"></div>
            <div class="s1-status-tag-name-wrap">
              <input class="s1-status-tag-name-input" v-model="tag.label" @blur="s1SaveStatusTags" />
            </div>
            <input class="s1-color-picker" type="color" v-model="tag.color" @change="s1SaveStatusTags" />
            <div class="s1-toggle s1-toggle-sm" :class="{ on: tag.enabled }" @click="tag.enabled = !tag.enabled; s1SaveStatusTags()">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>

        <div class="s1-subsection-hdr" style="margin-top:24px">Country Tier Assignments</div>
        <div class="s1-tier-info-bar">T1 = Premium (highest CPA) · T2 = Standard · T3 = Basic</div>
        <div class="s1-tier-grid">
          <div v-for="tier in ['T1','T2','T3']" :key="tier" class="s1-tier-card" :class="'s1-tier-' + tier.toLowerCase()">
            <div class="s1-tier-label">{{ tier }}</div>
            <textarea
              class="s1-tier-textarea"
              :value="s1CountryTiers[tier]"
              @input="s1CountryTiers[tier] = $event.target.value"
              @blur="s1SaveCountryTiers"
              placeholder="One country code per line (e.g. US, UK, AU)"
              rows="4"
            ></textarea>
          </div>
        </div>

        <div class="s1-subsection-hdr" style="margin-top:24px">General</div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Default currency</div>
            <div class="s1-row-desc">Currency used across all CRM reports</div>
          </div>
          <div class="s1-row-ctrl">
            <select class="s1-select" v-model="s1Settings.defaultCurrency" @change="s1AutoSave('defaultCurrency')">
              <option value="USD">USD — US Dollar</option>
              <option value="EUR">EUR — Euro</option>
              <option value="GBP">GBP — British Pound</option>
              <option value="ILS">ILS — Israeli Shekel</option>
            </select>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Date format</div>
            <div class="s1-row-desc">How dates appear across the interface</div>
          </div>
          <div class="s1-row-ctrl">
            <select class="s1-select" v-model="s1Settings.dateFormat" @change="s1AutoSave('dateFormat')">
              <option value="DD/MM/YYYY">DD/MM/YYYY</option>
              <option value="MM/DD/YYYY">MM/DD/YYYY</option>
              <option value="YYYY-MM-DD">YYYY-MM-DD</option>
            </select>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Timezone</div>
            <div class="s1-row-desc">Primary timezone for all time displays</div>
          </div>
          <div class="s1-row-ctrl">
            <select class="s1-select" v-model="s1Settings.timezone" @change="s1AutoSave('timezone')">
              <option value="Israel">Israel (UTC+2/+3)</option>
              <option value="UK">UK (UTC+0/+1)</option>
              <option value="UTC">UTC</option>
            </select>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Color blind mode</div>
            <div class="s1-row-desc">Adjust palette for color vision deficiencies</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.colorBlindMode }" @click="s1ToggleSetting('colorBlindMode')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Compact table rows</div>
            <div class="s1-row-desc">Reduce row height in all data tables</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.compactRows }" @click="s1ToggleSetting('compactRows')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- ═══ 8. NOTIFICATIONS (VIKI) ═══ -->
      <div v-if="s1ActiveSection === 'notifications'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Notifications</div>
          <div class="s1-section-sub">Configure Viki alert triggers, thresholds, and daily report timing</div>
        </div>

        <div class="s1-subsection-hdr">Alert Types</div>

        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">New deposit alert</div>
            <div class="s1-row-desc">Viki notifies when a deposit is recorded</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.notifDeposit }" @click="s1ToggleSetting('notifDeposit')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">New client registered</div>
            <div class="s1-row-desc">Alert when a new lead enters the CRM</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.notifNewClient }" @click="s1ToggleSetting('notifNewClient')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Shift start reminder</div>
            <div class="s1-row-desc">Alert 15 minutes before a shift begins</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.notifShiftStart }" @click="s1ToggleSetting('notifShiftStart')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Missed calls alert</div>
            <div class="s1-row-desc">Alert when missed calls exceed threshold</div>
          </div>
          <div class="s1-row-ctrl s1-row-ctrl-with-num">
            <div class="s1-toggle" :class="{ on: s1Settings.notifMissedCalls }" @click="s1ToggleSetting('notifMissedCalls')">
              <div class="s1-toggle-dot"></div>
            </div>
            <div class="s1-num-wrap" v-if="s1Settings.notifMissedCalls">
              <span class="s1-num-prefix">&gt;</span>
              <input class="s1-num-input" type="number" min="1" max="100" v-model.number="s1Settings.missedCallsThreshold" @change="s1AutoSave('missedCallsThreshold')" style="width:52px" />
              <span class="s1-num-unit">calls</span>
            </div>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Failed login alert</div>
            <div class="s1-row-desc">Notify on repeated failed login attempts</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.notifFailedLogin }" @click="s1ToggleSetting('notifFailedLogin')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Daily goal reached</div>
            <div class="s1-row-desc">Celebrate when the team hits the daily target</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.notifGoalReached }" @click="s1ToggleSetting('notifGoalReached')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Agent idle alert</div>
            <div class="s1-row-desc">Alert when an agent has no calls for extended period</div>
          </div>
          <div class="s1-row-ctrl s1-row-ctrl-with-num">
            <div class="s1-toggle" :class="{ on: s1Settings.notifAgentIdle }" @click="s1ToggleSetting('notifAgentIdle')">
              <div class="s1-toggle-dot"></div>
            </div>
            <div class="s1-num-wrap" v-if="s1Settings.notifAgentIdle">
              <input class="s1-num-input" type="number" min="5" max="240" v-model.number="s1Settings.agentIdleMinutes" @change="s1AutoSave('agentIdleMinutes')" style="width:52px" />
              <span class="s1-num-unit">min idle</span>
            </div>
          </div>
        </div>

        <div class="s1-subsection-hdr" style="margin-top:24px">Daily Report</div>
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Send daily stats report</div>
            <div class="s1-row-desc">Automated daily summary via Viki</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: s1Settings.dailyReport }" @click="s1ToggleSetting('dailyReport')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>
        <div class="s1-row" v-if="s1Settings.dailyReport">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Report send time</div>
            <div class="s1-row-desc">Time to send the daily report (team timezone)</div>
          </div>
          <div class="s1-row-ctrl">
            <input class="s1-select" type="time" v-model="s1Settings.dailyReportTime" @change="s1AutoSave('dailyReportTime')" style="font-size:13px;padding:6px 10px" />
          </div>
        </div>
        <div class="s1-row" v-if="s1Settings.dailyReport">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Include in report</div>
            <div class="s1-row-desc">What data sections to include</div>
          </div>
          <div class="s1-row-ctrl s1-row-ctrl-full">
            <div class="s1-check-group">
              <label class="s1-check-item"><input type="checkbox" v-model="s1Settings.reportIncDeposits" @change="s1AutoSave('reportIncDeposits')" /><span>Deposits</span></label>
              <label class="s1-check-item"><input type="checkbox" v-model="s1Settings.reportIncCalls" @change="s1AutoSave('reportIncCalls')" /><span>Calls</span></label>
              <label class="s1-check-item"><input type="checkbox" v-model="s1Settings.reportIncLeads" @change="s1AutoSave('reportIncLeads')" /><span>New Leads</span></label>
              <label class="s1-check-item"><input type="checkbox" v-model="s1Settings.reportIncAgents" @change="s1AutoSave('reportIncAgents')" /><span>Agent Rankings</span></label>
            </div>
          </div>
        </div>
      </div>

      <!-- ═══ 9. INTEGRATIONS ═══ -->
      <div v-if="s1ActiveSection === 'integrations'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Integrations</div>
          <div class="s1-section-sub">Connect external services: VOIP, email, SMS, and more</div>
        </div>

        <!-- VOIP -->
        <div class="s1-integration-block">
          <div class="s1-int-hdr">
            <div class="s1-int-icon s1-int-icon-voip">
              <svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.59 3.47a2 2 0 0 1 1.99-2.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 9.09a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            </div>
            <div class="s1-int-info">
              <div class="s1-int-name">VOIP Provider</div>
              <div class="s1-int-status" :class="{ 'connected': s1Settings.voipEnabled }">{{ s1Settings.voipEnabled ? 'Connected' : 'Not configured' }}</div>
            </div>
            <div class="s1-toggle" :class="{ on: s1Settings.voipEnabled }" @click="s1ToggleSetting('voipEnabled')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
          <div v-if="s1Settings.voipEnabled" class="s1-int-fields">
            <div class="s1-form-row">
              <label class="s1-form-lbl">Provider</label>
              <select class="s1-form-select" v-model="s1Settings.voipProvider" @change="s1AutoSave('voipProvider')">
                <option value="asterisk">Asterisk</option>
                <option value="twilio">Twilio</option>
                <option value="ringcentral">RingCentral</option>
                <option value="3cx">3CX</option>
                <option value="custom">Custom</option>
              </select>
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">API Key / SID</label>
              <input class="s1-form-input" v-model="s1Settings.voipApiKey" placeholder="API key or account SID" @blur="s1AutoSave('voipApiKey')" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Webhook URL</label>
              <input class="s1-form-input" v-model="s1Settings.voipWebhook" placeholder="https://your-crm.com/api/voip/webhook" @blur="s1AutoSave('voipWebhook')" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">SIP Server</label>
              <input class="s1-form-input" v-model="s1Settings.voipSipServer" placeholder="sip.provider.com:5060" @blur="s1AutoSave('voipSipServer')" />
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="s1-integration-block">
          <div class="s1-int-hdr">
            <div class="s1-int-icon s1-int-icon-email">
              <svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            </div>
            <div class="s1-int-info">
              <div class="s1-int-name">Email Provider (SMTP)</div>
              <div class="s1-int-status" :class="{ 'connected': s1Settings.emailEnabled }">{{ s1Settings.emailEnabled ? 'Connected' : 'Not configured' }}</div>
            </div>
            <div class="s1-toggle" :class="{ on: s1Settings.emailEnabled }" @click="s1ToggleSetting('emailEnabled')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
          <div v-if="s1Settings.emailEnabled" class="s1-int-fields">
            <div class="s1-form-row">
              <label class="s1-form-lbl">SMTP Host</label>
              <input class="s1-form-input" v-model="s1Settings.smtpHost" placeholder="smtp.provider.com" @blur="s1AutoSave('smtpHost')" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">SMTP Port</label>
              <input class="s1-form-input" v-model.number="s1Settings.smtpPort" placeholder="587" type="number" @blur="s1AutoSave('smtpPort')" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Username</label>
              <input class="s1-form-input" v-model="s1Settings.smtpUser" placeholder="noreply@gnm.com" @blur="s1AutoSave('smtpUser')" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Password</label>
              <input class="s1-form-input" v-model="s1Settings.smtpPass" placeholder="SMTP password" type="password" @blur="s1AutoSave('smtpPass')" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">From Name</label>
              <input class="s1-form-input" v-model="s1Settings.smtpFromName" placeholder="GNM CRM" @blur="s1AutoSave('smtpFromName')" />
            </div>
            <div class="s1-form-row s1-form-row-toggle">
              <label class="s1-form-lbl">Use TLS</label>
              <div class="s1-toggle" :class="{ on: s1Settings.smtpTLS }" @click="s1ToggleSetting('smtpTLS')">
                <div class="s1-toggle-dot"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- SMS -->
        <div class="s1-integration-block">
          <div class="s1-int-hdr">
            <div class="s1-int-icon s1-int-icon-sms">
              <svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            </div>
            <div class="s1-int-info">
              <div class="s1-int-name">SMS Provider</div>
              <div class="s1-int-status" :class="{ 'connected': s1Settings.smsEnabled }">{{ s1Settings.smsEnabled ? 'Connected' : 'Not configured' }}</div>
            </div>
            <div class="s1-toggle" :class="{ on: s1Settings.smsEnabled }" @click="s1ToggleSetting('smsEnabled')">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
          <div v-if="s1Settings.smsEnabled" class="s1-int-fields">
            <div class="s1-form-row">
              <label class="s1-form-lbl">Provider</label>
              <select class="s1-form-select" v-model="s1Settings.smsProvider" @change="s1AutoSave('smsProvider')">
                <option value="twilio">Twilio</option>
                <option value="vonage">Vonage</option>
                <option value="messagebird">MessageBird</option>
              </select>
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">API Key</label>
              <input class="s1-form-input" v-model="s1Settings.smsApiKey" placeholder="SMS provider API key" @blur="s1AutoSave('smsApiKey')" />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Sender ID</label>
              <input class="s1-form-input" v-model="s1Settings.smsSenderId" placeholder="GNM or +1555..." @blur="s1AutoSave('smsSenderId')" />
            </div>
          </div>
        </div>

        <!-- WhatsApp -->
        <div class="s1-integration-block s1-int-coming-soon">
          <div class="s1-int-hdr">
            <div class="s1-int-icon s1-int-icon-wa">
              <svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
            </div>
            <div class="s1-int-info">
              <div class="s1-int-name">WhatsApp Business</div>
              <div class="s1-int-status">Coming soon</div>
            </div>
            <span class="s1-coming-soon-badge">Soon</span>
          </div>
        </div>

        <!-- Google Ads -->
        <div class="s1-integration-block s1-int-broken">
          <div class="s1-int-hdr">
            <div class="s1-int-icon s1-int-icon-google">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
            </div>
            <div class="s1-int-info">
              <div class="s1-int-name">Google Ads API</div>
              <div class="s1-int-status s1-int-status-broken">Currently broken — API credentials expired</div>
            </div>
            <span class="s1-broken-badge">Broken</span>
          </div>
          <div class="s1-int-fields">
            <div class="s1-form-row">
              <label class="s1-form-lbl">Client ID</label>
              <input class="s1-form-input" v-model="s1Settings.googleAdsClientId" placeholder="Google Ads client ID" @blur="s1AutoSave('googleAdsClientId')" disabled />
            </div>
            <div class="s1-form-row">
              <label class="s1-form-lbl">Developer Token</label>
              <input class="s1-form-input" v-model="s1Settings.googleAdsToken" placeholder="Developer token" @blur="s1AutoSave('googleAdsToken')" disabled />
            </div>
          </div>
        </div>

        <!-- API Keys section -->
        <div class="s1-subsection-hdr" style="margin-top:28px">Internal API Keys</div>
        <div v-if="!s1AdminOnly" class="s1-admin-gate">
          <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Admin access required
        </div>
        <template v-else>
          <div v-if="s1ApiKeys.length === 0" class="s1-api-empty">No API keys yet</div>
          <div v-for="key in s1ApiKeys" :key="key.id" class="s1-api-row">
            <div class="s1-api-key-info">
              <div class="s1-api-key-name">{{ key.name }}</div>
              <div class="s1-api-key-val">
                <span class="s1-api-masked">{{ s1MaskKey(key.value) }}</span>
                <button class="s1-api-copy" @click="s1CopyKey(key.value)" title="Copy key">
                  <svg viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                </button>
              </div>
              <div class="s1-api-meta">Created {{ key.created }}</div>
            </div>
            <button class="s1-api-revoke" @click="s1RevokeKey(key.id)">Revoke</button>
          </div>
          <div class="s1-api-gen-row">
            <input class="s1-api-name-input" v-model.trim="s1NewKeyName" placeholder="Key name (e.g. Zapier)" />
            <button class="s1-api-gen-btn" @click="s1GenerateKey" :disabled="!s1NewKeyName || s1ApiGenerating">
              <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              {{ s1ApiGenerating ? 'Generating…' : 'Generate key' }}
            </button>
          </div>
          <transition name="s1-fadein">
            <div v-if="s1NewKeyRevealed" class="s1-key-reveal">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Copy this key now — it won't be shown again:
              <code class="s1-key-reveal-val">{{ s1NewKeyRevealed }}</code>
              <button class="s1-key-reveal-copy" @click="s1CopyKey(s1NewKeyRevealed)">Copy</button>
            </div>
          </transition>
        </template>
      </div>

      <!-- ═══ 10. BILLING / PLANS ═══ -->
      <div v-if="s1ActiveSection === 'billing'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Billing &amp; Plans</div>
          <div class="s1-section-sub">Manage subscription plan and seat allocation</div>
        </div>
        <div v-if="!s1AdminOnly" class="s1-admin-gate">
          <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Admin access required
        </div>
        <template v-else>
          <!-- Current plan -->
          <div class="s1-current-plan-card">
            <div class="s1-plan-badge" :class="'s1-plan-' + s1CurrentPlan.key">{{ s1CurrentPlan.label }}</div>
            <div class="s1-plan-detail-grid">
              <div class="s1-plan-detail-item">
                <div class="s1-plan-detail-val">{{ s1CurrentPlan.seats }}</div>
                <div class="s1-plan-detail-lbl">Seats</div>
              </div>
              <div class="s1-plan-detail-item">
                <div class="s1-plan-detail-val">{{ s1CurrentPlan.price }}</div>
                <div class="s1-plan-detail-lbl">Per month</div>
              </div>
              <div class="s1-plan-detail-item">
                <div class="s1-plan-detail-val">{{ s1Users.length }}</div>
                <div class="s1-plan-detail-lbl">Used seats</div>
              </div>
              <div class="s1-plan-detail-item">
                <div class="s1-plan-detail-val s1-plan-remaining" :class="{ warn: s1SeatsFull }">{{ s1CurrentPlan.seats - s1Users.length }}</div>
                <div class="s1-plan-detail-lbl">Remaining</div>
              </div>
            </div>
          </div>

          <!-- Plan cards -->
          <div class="s1-subsection-hdr" style="margin-top:24px">Available Plans</div>
          <div class="s1-plan-grid">
            <div v-for="plan in s1Plans" :key="plan.key" class="s1-plan-card" :class="{ 'current': plan.key === s1Settings.plan, 's1-plan-card-president': plan.key === 'president' }">
              <div class="s1-plan-card-name">{{ plan.label }}</div>
              <div class="s1-plan-card-price">{{ plan.price }}<span class="s1-plan-mo">/mo</span></div>
              <div class="s1-plan-card-seats">{{ plan.seats }} seats</div>
              <ul class="s1-plan-features">
                <li v-for="f in plan.features" :key="f">
                  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                  {{ f }}
                </li>
              </ul>
              <button
                class="s1-plan-select-btn"
                :class="{ 'current-plan-btn': plan.key === s1Settings.plan }"
                @click="plan.key !== s1Settings.plan && s1SelectPlan(plan)"
                :disabled="plan.key === s1Settings.plan"
              >
                {{ plan.key === s1Settings.plan ? 'Current plan' : 'Switch to ' + plan.label }}
              </button>
            </div>
          </div>

          <!-- Billing info -->
          <div class="s1-subsection-hdr" style="margin-top:28px">Billing Information</div>
          <div class="s1-row">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Company name</div>
              <div class="s1-row-desc">Appears on invoices</div>
            </div>
            <div class="s1-row-ctrl s1-row-ctrl-full">
              <input class="s1-form-input" v-model="s1Settings.billingCompany" @blur="s1AutoSave('billingCompany')" placeholder="GNM Ltd." />
            </div>
          </div>
          <div class="s1-row">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Billing email</div>
              <div class="s1-row-desc">Where invoices are sent</div>
            </div>
            <div class="s1-row-ctrl s1-row-ctrl-full">
              <input class="s1-form-input" v-model="s1Settings.billingEmail" @blur="s1AutoSave('billingEmail')" placeholder="billing@gnm.com" type="email" />
            </div>
          </div>
          <div class="s1-row">
            <div class="s1-row-lbl">
              <div class="s1-row-name">VAT / Tax ID</div>
              <div class="s1-row-desc">Optional tax ID for invoices</div>
            </div>
            <div class="s1-row-ctrl s1-row-ctrl-full">
              <input class="s1-form-input" v-model="s1Settings.billingVAT" @blur="s1AutoSave('billingVAT')" placeholder="e.g. IL123456789" />
            </div>
          </div>
        </template>
      </div>

      <!-- SECURITY (also accessible via settings) -->
      <div v-if="s1ActiveSection === 'security'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Security</div>
          <div class="s1-section-sub">Login restrictions, 2FA, and IP whitelisting</div>
        </div>
        <div v-if="!s1AdminOnly" class="s1-admin-gate">
          <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Admin access required
        </div>
        <template v-else>
          <div class="s1-row">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Two-factor authentication</div>
              <div class="s1-row-desc">Require 2FA for all admin logins</div>
            </div>
            <div class="s1-row-ctrl">
              <div class="s1-toggle" :class="{ on: s1Settings.require2FA }" @click="s1ToggleSetting('require2FA')">
                <div class="s1-toggle-dot"></div>
              </div>
            </div>
          </div>
          <div class="s1-row">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Force IP restriction</div>
              <div class="s1-row-desc">Block logins from IPs not in the allowed list</div>
            </div>
            <div class="s1-row-ctrl">
              <div class="s1-toggle" :class="{ on: s1Settings.forceIPRestriction }" @click="s1ToggleSetting('forceIPRestriction')">
                <div class="s1-toggle-dot"></div>
              </div>
            </div>
          </div>
          <div class="s1-row s1-row-tall">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Allowed IP ranges</div>
              <div class="s1-row-desc">One CIDR per line (e.g. 192.168.1.0/24)</div>
            </div>
            <div class="s1-row-ctrl s1-row-ctrl-full">
              <textarea class="s1-textarea" v-model="s1Settings.allowedIPs" rows="3" placeholder="0.0.0.0/0" @blur="s1AutoSave('allowedIPs')"></textarea>
            </div>
          </div>
          <div class="s1-row">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Session timeout</div>
              <div class="s1-row-desc">Minutes of inactivity before logout</div>
            </div>
            <div class="s1-row-ctrl">
              <div class="s1-num-wrap">
                <input class="s1-num-input" type="number" min="5" max="1440" v-model.number="s1Settings.sessionTimeout" @change="s1AutoSave('sessionTimeout')" />
                <span class="s1-num-unit">min</span>
              </div>
            </div>
          </div>
          <div class="s1-row">
            <div class="s1-row-lbl">
              <div class="s1-row-name">Max login attempts</div>
              <div class="s1-row-desc">Failed attempts before account lock</div>
            </div>
            <div class="s1-row-ctrl">
              <div class="s1-num-wrap">
                <input class="s1-num-input" type="number" min="1" max="20" v-model.number="s1Settings.maxLoginAttempts" @change="s1AutoSave('maxLoginAttempts')" />
                <span class="s1-num-unit">tries</span>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- ═══ VIOPA AI ═══ -->
      <div v-if="s1ActiveSection === 'viopa'" class="s1-section">
        <div class="s1-section-hdr">
          <div class="s1-section-title">Viopa AI</div>
          <div class="s1-section-sub">AI scoring weights, transfer rules, and enable/disable control</div>
        </div>

        <!-- Enable/disable toggle -->
        <div class="s1-row">
          <div class="s1-row-lbl">
            <div class="s1-row-name">Viopa AI enabled</div>
            <div class="s1-row-desc">Enable or disable the Viopa AI scoring engine globally</div>
          </div>
          <div class="s1-row-ctrl">
            <div class="s1-toggle" :class="{ on: sec1ViopaEnabled }" @click="sec1ViopaEnabled = !sec1ViopaEnabled">
              <div class="s1-toggle-dot"></div>
            </div>
          </div>
        </div>

        <!-- Loading state -->
        <div v-if="sec1ViopaLoading" class="s1-viopa-loading">
          <div class="c1-spinner"></div>
          <span>Loading Viopa AI configuration…</span>
        </div>

        <template v-else>
          <!-- Score weights -->
          <div class="s1-subsection-hdr">Scoring Weights</div>
          <template v-if="sec1ViopaScore && typeof sec1ViopaScore === 'object'">
            <div v-for="(val, key) in sec1ViopaScore" :key="'vs-'+key" class="s1-row">
              <div class="s1-row-lbl">
                <div class="s1-row-name">{{ sec1ViopaKeyLabel(key) }}</div>
                <div class="s1-row-desc s1-viopa-key-raw">{{ key }}</div>
              </div>
              <div class="s1-row-ctrl">
                <div class="s1-num-wrap">
                  <input class="s1-num-input s1-viopa-num" type="number" step="0.01" :value="val" readonly />
                </div>
              </div>
            </div>
          </template>
          <div v-else class="s1-viopa-empty">No score configuration returned from API</div>

          <!-- Transfer score weights -->
          <div class="s1-subsection-hdr" style="margin-top:16px">Transfer Score Weights</div>
          <template v-if="sec1ViopaTransfer && typeof sec1ViopaTransfer === 'object'">
            <div v-for="(val, key) in sec1ViopaTransfer" :key="'vt-'+key" class="s1-row">
              <div class="s1-row-lbl">
                <div class="s1-row-name">{{ sec1ViopaKeyLabel(key) }}</div>
                <div class="s1-row-desc s1-viopa-key-raw">{{ key }}</div>
              </div>
              <div class="s1-row-ctrl">
                <div class="s1-num-wrap">
                  <input class="s1-num-input s1-viopa-num" type="number" step="0.01" :value="val" readonly />
                </div>
              </div>
            </div>
          </template>
          <div v-else class="s1-viopa-empty">No transfer score configuration returned from API</div>
        </template>
      </div>

    </div><!-- /s1-content -->
  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import axios from "axios";

const API = "/api";

function authHeaders() {
  return { Authorization: "Bearer " + localStorage.getItem("user-token") };
}

function apiGet(path) {
  return axios.get(API + path, { headers: authHeaders() });
}
function apiPost(path, data) {
  return axios.post(API + path, data, { headers: authHeaders() });
}
function apiPut(path, data) {
  return axios.put(API + path, data, { headers: authHeaders() });
}

export default {
  name: "Settings1Container",

  components: { VikiFace },

  data() {
    return {
      c1Status: 'shift',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      // UI state
      c1TopTab: null,
      s1SlideOpen: 'nav',
      s1PanelActiveContent: null,
      s1ActiveCat: "all",
      s1ActiveSection: null,
      s1SavedVisible: false,
      s1SavedTimer: null,
      s1Toast: null,
      s1ToastTimer: null,

      // Categories for filter panel + card grid
      s1Categories: [
        { key: "all",           label: "All" },
        { key: "users",         label: "Users & Roles",       desc: "Manage team members, roles, permissions",    color: "#6366f1", iconPath: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>' },
        { key: "brokers",       label: "Brokers",             desc: "Add, edit and deactivate brokers",           color: "#22c55e", iconPath: '<rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>' },
        { key: "campaigns",     label: "Campaigns",           desc: "Track marketing, costs and CPL",             color: "#f59e0b", iconPath: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>' },
        { key: "games",         label: "Games Permissions",   desc: "Control game access per agent",              color: "#a855f7", iconPath: '<line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/><circle cx="15" cy="13" r="1"/><circle cx="18" cy="11" r="1"/><rect x="2" y="6" width="20" height="12" rx="2"/>' },
        { key: "goals",         label: "Deposit Goals",       desc: "Set daily and monthly deposit targets",      color: "#ef4444", iconPath: '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>' },
        { key: "logs",          label: "System Logs",         desc: "Raw system activity and audit log",          color: "#64748b", iconPath: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>' },
        { key: "crm",           label: "CRM Configuration",  desc: "Status tags, country tiers, display",        color: "#3b82f6", iconPath: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>' },
        { key: "notifications", label: "Notifications",       desc: "Viki alerts, thresholds, daily report",      color: "#f59e0b", iconPath: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>' },
        { key: "integrations",  label: "Integrations",        desc: "VOIP, email, SMS, API keys",                 color: "#06b6d4", iconPath: '<polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>' },
        { key: "billing",       label: "Billing / Plans",     desc: "Subscription plan and seat management",      color: "#22c55e", iconPath: '<rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>' },
        { key: "security",      label: "Security",            desc: "2FA, IP lock, session and login limits",     color: "#ef4444", iconPath: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>' },
        { key: "viopa",         label: "Viopa AI",            desc: "AI scoring weights, transfer rules, enable/disable", color: "#7c3aed", iconPath: '<circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>' }
      ],

      // ── Viopa AI ──────────────────────────────────────────
      sec1ViopaScore: null,
      sec1ViopaTransfer: null,
      sec1ViopaLoading: false,
      sec1ViopaEnabled: true,

      // Role maps
      s1RoleMap: { 1: "Admin", 2: "VP Sales", 3: "Manager", 4: "Agent", 5: "Chat Agent" },
      s1RoleDesc: {
        1: "Full system access, billing, user management",
        2: "View all teams, override assignments",
        3: "Manage own team agents and reports",
        4: "Standard agent — clients, calls, deposits",
        5: "Chat and messaging only"
      },

      // Settings model — all keys, auto-saved on change
      s1Settings: {
        // Users
        defaultRole: "4",
        allowedIPs: "",
        sessionTimeout: 60,
        maxLoginAttempts: 5,
        // Finance / CRM
        defaultCurrency: "USD",
        dateFormat: "DD/MM/YYYY",
        timezone: "Israel",
        colorBlindMode: false,
        compactRows: false,
        callCostPerMin: 0.04,
        // Notifications
        notifDeposit: true,
        notifNewClient: true,
        notifShiftStart: false,
        notifFailedLogin: true,
        notifMissedCalls: false,
        missedCallsThreshold: 5,
        notifGoalReached: true,
        notifAgentIdle: false,
        agentIdleMinutes: 30,
        dailyReport: false,
        dailyReportTime: "18:00",
        reportIncDeposits: true,
        reportIncCalls: true,
        reportIncLeads: false,
        reportIncAgents: true,
        // Goals
        goalAlerts: true,
        goalWarnBehind: true,
        // Games
        gamesEnabled: true,
        gamesDefaultLimit: 60,
        // Security
        require2FA: false,
        forceIPRestriction: false,
        // Integrations — VOIP
        voipEnabled: false,
        voipProvider: "asterisk",
        voipApiKey: "",
        voipWebhook: "",
        voipSipServer: "",
        // Email
        emailEnabled: false,
        smtpHost: "",
        smtpPort: 587,
        smtpUser: "",
        smtpPass: "",
        smtpFromName: "GNM CRM",
        smtpTLS: true,
        // SMS
        smsEnabled: false,
        smsProvider: "twilio",
        smsApiKey: "",
        smsSenderId: "",
        // Google Ads
        googleAdsClientId: "",
        googleAdsToken: "",
        // Billing
        plan: "standard",
        billingCompany: "",
        billingEmail: "",
        billingVAT: ""
      },

      // Users section
      s1Users: [],
      s1UsersLoading: false,
      s1UserSearch: "",
      s1UserRoleFilter: "",
      s1AddUserOpen: false,
      s1EditUser: null,
      s1UserSaving: false,
      s1UserFormError: "",
      s1UserForm: {
        first_name: "", last_name: "", email: "", password: "",
        role: 4, team: "", extension: ""
      },

      // Brokers section
      s1Brokers: [],
      s1BrokersLoading: false,
      s1AddBrokerOpen: false,
      s1EditBroker: null,
      s1BrokerSaving: false,
      s1BrokerFormError: "",
      s1BrokerForm: {
        name: "", cpa: 0, deposit_methods: "", contact_email: "", country: "", active: true
      },

      // Campaigns section
      s1Campaigns: [],
      s1CampaignsLoading: false,
      s1AddCampaignOpen: false,
      s1EditCampaign: null,
      s1CampaignSaving: false,
      s1CampaignFormError: "",
      s1CampaignForm: {
        name: "", source: "google", budget: 0, cpl: 0, start_date: "", end_date: "", active: true
      },
      s1CplSources: [
        { key: "google",   label: "Google Ads", cpl: 28 },
        { key: "facebook", label: "Facebook",   cpl: 18 },
        { key: "bing",     label: "Bing",       cpl: 22 },
        { key: "tiktok",   label: "TikTok",     cpl: 14 },
        { key: "organic",  label: "Organic",    cpl: 0  },
        { key: "referral", label: "Referral",   cpl: 0  }
      ],

      // Games permissions
      s1GamesDrawerOpen: false,
      s1GamesLoading: false,
      s1Games: [
        { id: 1, name: "Tetris" },
        { id: 2, name: "Snake" },
        { id: 3, name: "Pong" },
        { id: 4, name: "TicTacToe" },
        { id: 5, name: "Memory" }
      ],
      s1PermUsers: [],
      s1PermUserRecords: [],
      s1Permissions: {},
      s1GameLimits: {},
      s1GamesSearchName: "",

      // Deposit goals
      s1Goals: {
        daily_target: 0,
        daily_current: 0,
        weekly_target: 0,
        weekly_current: 0,
        monthly_target: 0,
        monthly_current: 0
      },
      s1GoalDailyObj: null,
      s1GoalWeeklyObj: null,
      s1GoalMonthlyObj: null,
      s1GoalDailyInput: 0,
      s1GoalWeeklyInput: 0,
      s1GoalMonthlyInput: 0,
      s1GoalSaving: false,
      s1GoalHistory: [],
      s1GoalHistoryLoading: false,
      s1AgentGoals: {},
      s1GoalAgentOpen: false,
      s1GoalUsers: [],
      s1GoalUsersLoading: false,

      // System logs
      s1Logs: [],
      s1LogsLoading: false,
      s1LogSearch: "",
      s1LogTypeFilter: "",
      s1LogDrawerOpen: false,
      s1LogSubTab: "system",
      s1SysLogData: [],
      s1SysLogPage: 1,
      s1SysLogSortOrder: "desc",
      s1SysLogLoading: false,
      s1ClientLogData: [],
      s1ClientLogPage: 1,
      s1ClientLogSortOrder: "desc",
      s1ClientLogLoading: false,
      s1TaskLogData: [],
      s1TaskLogPage: 1,
      s1TaskLogLoading: false,

      // CRM config
      s1StatusTags: [
        { key: "deposit",  label: "Deposit",      color: "#22c55e", enabled: true },
        { key: "lead",     label: "Lead",         color: "#f59e0b", enabled: true },
        { key: "na",       label: "No Answer",    color: "#ef4444", enabled: true },
        { key: "sc",       label: "Scheduled",    color: "#3b82f6", enabled: true },
        { key: "rf",       label: "Referral",     color: "#a855f7", enabled: true },
        { key: "tr",       label: "Transfer",     color: "#ca8a04", enabled: true },
        { key: "bn",       label: "Bad Number",   color: "#6b7280", enabled: true },
        { key: "ni",       label: "Not Interested", color: "#92400e", enabled: true },
        { key: "waiting",  label: "Waiting",      color: "#4b5563", enabled: true }
      ],
      s1CountryTiers: {
        T1: "US\nUK\nAU\nCA\nDE\nCH\nNO\nSE\nDK",
        T2: "FR\nIT\nES\nNL\nBE\nAT\nFI\nPT\nIE",
        T3: "IL\nCY\nGR\nPL\nCZ\nHU\nRO\nBG"
      },

      // API Keys
      s1ApiKeys: [
        { id: 1, name: "Zapier Integration",    value: "gnm_live_abc123xyz789qwerty", created: "Dec 2023" },
        { id: 2, name: "Internal Dashboard",   value: "gnm_live_def456uvw012asdfgh", created: "Jan 2024" }
      ],
      s1NewKeyName: "",
      s1ApiGenerating: false,
      s1NewKeyRevealed: null,

      // Billing plans
      s1Plans: [
        {
          key: "standard", label: "Standard", price: "$299", seats: 10,
          features: ["10 user seats", "Basic reports", "Email support", "1 broker", "Standard VOIP"]
        },
        {
          key: "pro", label: "Pro", price: "$599", seats: 30,
          features: ["30 user seats", "Advanced analytics", "Priority support", "5 brokers", "Games module", "API access"]
        },
        {
          key: "unlimited", label: "Unlimited", price: "$999", seats: 100,
          features: ["100 user seats", "Full analytics suite", "Dedicated support", "Unlimited brokers", "All modules", "Custom integrations"]
        },
        {
          key: "president", label: "President", price: "Custom", seats: 999,
          features: ["Unlimited seats", "White-label option", "SLA guarantee", "Custom development", "On-site training", "Direct dev line"]
        }
      ],

      // Clock
      s1Clock: null,
      s1TimeUK: "",
      s1TimeIL: ""
    };
  },

  computed: {
    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return [u.first_name, u.last_name].filter(Boolean).join(" ") || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "";
      const map = { admin: "Admin", manager: "Manager", agent: "Agent", broker: "Broker" };
      return map[u.role] || u.role || "";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },

    s1PanelIsOpen() {
      return !!this.s1SlideOpen && this.s1SlideOpen !== 'menu';
    },
    s1PanelAtContent() {
      return this.s1PanelIsOpen && this.s1SlideOpen !== 'nav';
    },
    s1ActivePanelLabel() {
      if (!this.s1PanelIsOpen || this.s1SlideOpen === 'nav') return 'Panels';
      return this.s1PanelActiveContent ? (this.s1PanelActiveContent.charAt(0).toUpperCase() + this.s1PanelActiveContent.slice(1)) : 'Panels';
    },

    s1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "GN";
      return (((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase()) || "GN";
    },
    s1UserName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return (u.first_name || "") + " " + (u.last_name || "");
    },
    s1RoleLabel() {
      const roleMap = { 1: "Admin", 2: "VP Sales", 3: "Manager", 4: "Agent", 5: "Chat Agent", 12: "Super Admin" };
      const role = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user && this.$store.state.user.auth.user.role;
      return roleMap[role] || "User";
    },
    s1AdminOnly() {
      const role = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user && this.$store.state.user.auth.user.role;
      return role === 1 || role === 12;
    },
    s1TzUK() { return this.s1TimeUK; },
    s1TzIL() { return this.s1TimeIL; },

    s1FilteredUsers() {
      let list = this.s1Users;
      if (this.s1UserSearch) {
        const q = this.s1UserSearch.toLowerCase();
        list = list.filter(u =>
          (u.first_name + " " + u.last_name).toLowerCase().includes(q) ||
          (u.email || "").toLowerCase().includes(q)
        );
      }
      if (this.s1UserRoleFilter) {
        list = list.filter(u => String(u.role) === String(this.s1UserRoleFilter));
      }
      return list;
    },

    s1FilteredLogs() {
      let list = this.s1Logs;
      if (this.s1LogTypeFilter) {
        list = list.filter(l => l.type === this.s1LogTypeFilter);
      }
      if (this.s1LogSearch) {
        const q = this.s1LogSearch.toLowerCase();
        list = list.filter(l =>
          (l.message || "").toLowerCase().includes(q) ||
          (l.user_name || "").toLowerCase().includes(q)
        );
      }
      return list;
    },

    s1ActiveNotifCount() {
      const s = this.s1Settings;
      return [s.notifDeposit, s.notifNewClient, s.notifShiftStart, s.notifFailedLogin,
              s.notifMissedCalls, s.notifGoalReached, s.notifAgentIdle, s.dailyReport].filter(Boolean).length;
    },

    s1CurrentPlan() {
      return this.s1Plans.find(p => p.key === this.s1Settings.plan) || this.s1Plans[0];
    },

    s1SeatsFull() {
      return this.s1Users.length >= this.s1CurrentPlan.seats;
    },

    s1FilteredPermUsers() {
      if (!this.s1GamesSearchName) return this.s1PermUsers;
      const q = this.s1GamesSearchName.toLowerCase();
      return this.s1PermUsers.filter(u =>
        ((u.first_name || '') + ' ' + (u.last_name || '')).toLowerCase().includes(q) ||
        (u.email || '').toLowerCase().includes(q)
      );
    }
  },

  watch: {
    's1SlideOpen': function(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.s1PanelActiveContent = val;
      }
    }
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },

    // ── Slide / panel helpers ──────────────────────────────────────────────
    s1PanelBtnClick() {
      this.s1SlideOpen = this.s1PanelIsOpen ? null : 'nav';
    },
    s1SelectPanel(panel) {
      this.s1SlideOpen = panel;
    },
    s1FilterPanelClick(e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    s1OpenSlide(name) {
      this.s1SlideOpen = this.s1SlideOpen === name ? null : name;
    },

    s1SetCat(key) {
      this.s1ActiveCat = key;
    },

    s1OpenSection(key) {
      if (this.s1ActiveSection === key) {
        this.s1ActiveSection = null;
        return;
      }
      this.s1ActiveSection = key;
      this.s1SlideOpen = null;
      // Load data for section
      if (key === "users")      this.s1LoadUsers();
      if (key === "brokers")    this.s1LoadBrokers();
      if (key === "campaigns")  this.s1LoadCampaigns();
      if (key === "games")      this.s1LoadPermissions();
      if (key === "goals")      this.s1LoadGoals();
      if (key === "logs")       this.s1LoadLogs();
      if (key === "viopa")      this.sec1LoadViopa();
    },

    // ── Toast ──────────────────────────────────────────────────────────────
    s1ShowToast(msg, color) {
      this.s1Toast = { msg, color: color || "#22c55e" };
      if (this.s1ToastTimer) clearTimeout(this.s1ToastTimer);
      this.s1ToastTimer = setTimeout(() => { this.s1Toast = null; }, 2800);
    },

    s1ShowSaved() {
      this.s1SavedVisible = true;
      if (this.s1SavedTimer) clearTimeout(this.s1SavedTimer);
      this.s1SavedTimer = setTimeout(() => { this.s1SavedVisible = false; }, 1800);
    },

    // ── Auto-save with toast ───────────────────────────────────────────────
    s1AutoSave(key) {
      this.s1ShowSaved();
      // No generic /settings PUT endpoint — settings are saved per-subsystem
      // Silently persist to localStorage as fallback
      try { localStorage.setItem('s1_setting_' + key, JSON.stringify(this.s1Settings[key])); } catch(e) {}
    },

    s1ToggleSetting(key) {
      this.s1Settings[key] = !this.s1Settings[key];
      this.s1AutoSave(key);
    },

    // ── Load settings from API ─────────────────────────────────────────────
    async s1FetchSettings() {
      // No generic /settings GET endpoint — restore from localStorage if available
      try {
        Object.keys(this.s1Settings).forEach(key => {
          const val = localStorage.getItem('s1_setting_' + key);
          if (val !== null) {
            try { this.s1Settings[key] = JSON.parse(val); } catch(e) {}
          }
        });
      } catch (e) { /* use defaults */ }
    },

    // ── Users ──────────────────────────────────────────────────────────────
    async s1LoadUsers() {
      this.s1UsersLoading = true;
      try {
        const res = await apiGet("/admin/user");
        this.s1Users = (res.data && (res.data.data || res.data)) || [];
      } catch (e) {
        this.s1Users = [];
      } finally {
        this.s1UsersLoading = false;
      }
    },

    s1OpenAddUser() {
      this.s1EditUser = null;
      this.s1UserForm = { first_name: "", last_name: "", email: "", password: "", role: 4, team: "", extension: "" };
      this.s1UserFormError = "";
      this.s1AddUserOpen = true;
    },

    s1OpenEditUser(user) {
      this.s1EditUser = user;
      this.s1UserForm = {
        first_name: user.first_name || "",
        last_name:  user.last_name  || "",
        email:      user.email      || "",
        password:   "",
        role:       user.role       || 4,
        team:       user.team       || "",
        extension:  user.extension  || ""
      };
      this.s1UserFormError = "";
      this.s1AddUserOpen = true;
    },

    async s1SubmitUser() {
      if (!this.s1UserForm.first_name || !this.s1UserForm.email) {
        this.s1UserFormError = "First name and email are required.";
        return;
      }
      if (!this.s1EditUser && !this.s1UserForm.password) {
        this.s1UserFormError = "Password is required for new users.";
        return;
      }
      this.s1UserSaving = true;
      this.s1UserFormError = "";
      try {
        if (this.s1EditUser) {
          const payload = { ...this.s1UserForm };
          delete payload.password;
          await apiPut("/admin/user/" + this.s1EditUser.id, payload);
          Object.assign(this.s1EditUser, payload);
        } else {
          const res = await apiPost("/admin/user", this.s1UserForm);
          const created = (res.data && res.data.data) || res.data;
          if (created) this.s1Users.push(created);
        }
        this.s1AddUserOpen = false;
        this.s1ShowToast(this.s1EditUser ? "User updated" : "User created");
      } catch (e) {
        this.s1UserFormError = (e.response && e.response.data && e.response.data.message) || "Failed to save user.";
      } finally {
        this.s1UserSaving = false;
      }
    },

    async s1ToggleUserActive(user) {
      const prev = user.active;
      this.$set(user, "active", !user.active);
      try {
        await apiPut("/admin/user/" + user.id, { active: user.active });
        this.s1ShowSaved();
      } catch (e) {
        this.$set(user, "active", prev);
      }
    },

    // ── Brokers ─────────────────────────────────────────────────────────────
    async s1LoadBrokers() {
      this.s1BrokersLoading = true;
      try {
        const res = await apiGet("/admin/brokers");
        this.s1Brokers = (res.data && (res.data.data || res.data)) || [];
      } catch (e) {
        this.s1Brokers = [];
      } finally {
        this.s1BrokersLoading = false;
      }
    },

    s1OpenAddBroker() {
      this.s1EditBroker = null;
      this.s1BrokerForm = { name: "", cpa: 0, deposit_methods: "", contact_email: "", country: "", active: true };
      this.s1BrokerFormError = "";
      this.s1AddBrokerOpen = true;
    },

    s1OpenEditBroker(broker) {
      this.s1EditBroker = broker;
      this.s1BrokerForm = {
        name:            broker.name            || "",
        cpa:             broker.cpa             || 0,
        deposit_methods: broker.deposit_methods || "",
        contact_email:   broker.contact_email   || "",
        country:         broker.country         || "",
        active:          broker.active !== false
      };
      this.s1BrokerFormError = "";
      this.s1AddBrokerOpen = true;
    },

    async s1SubmitBroker() {
      if (!this.s1BrokerForm.name) {
        this.s1BrokerFormError = "Broker name is required.";
        return;
      }
      this.s1BrokerSaving = true;
      this.s1BrokerFormError = "";
      try {
        if (this.s1EditBroker) {
          await apiPut("/admin/broker/" + this.s1EditBroker.id, this.s1BrokerForm);
          Object.assign(this.s1EditBroker, this.s1BrokerForm);
        } else {
          const res = await apiPost("/admin/broker", this.s1BrokerForm);
          const created = (res.data && res.data.data) || res.data;
          if (created) this.s1Brokers.push(created);
        }
        this.s1AddBrokerOpen = false;
        this.s1ShowToast(this.s1EditBroker ? "Broker updated" : "Broker created");
      } catch (e) {
        this.s1BrokerFormError = (e.response && e.response.data && e.response.data.message) || "Failed to save broker.";
      } finally {
        this.s1BrokerSaving = false;
      }
    },

    async s1ToggleBrokerActive(broker) {
      const prev = broker.active;
      this.$set(broker, "active", !broker.active);
      try {
        await apiPut("/admin/broker/" + broker.id, { active: broker.active });
        this.s1ShowSaved();
      } catch (e) {
        this.$set(broker, "active", prev);
      }
    },

    // ── Campaigns ──────────────────────────────────────────────────────────
    async s1LoadCampaigns() {
      this.s1CampaignsLoading = true;
      try {
        const res = await apiGet("/admin/campaigns");
        this.s1Campaigns = (res.data && (res.data.data || res.data)) || [];
      } catch (e) {
        this.s1Campaigns = [];
      } finally {
        this.s1CampaignsLoading = false;
      }
    },

    s1OpenAddCampaign() {
      this.s1EditCampaign = null;
      this.s1CampaignForm = { name: "", source: "google", budget: 0, cpl: 0, start_date: "", end_date: "", active: true };
      this.s1CampaignFormError = "";
      this.s1AddCampaignOpen = true;
    },

    s1OpenEditCampaign(camp) {
      this.s1EditCampaign = camp;
      this.s1CampaignForm = {
        name:       camp.name       || "",
        source:     camp.source     || "google",
        budget:     camp.budget     || 0,
        cpl:        camp.cpl        || 0,
        start_date: camp.start_date || "",
        end_date:   camp.end_date   || "",
        active:     camp.active !== false
      };
      this.s1CampaignFormError = "";
      this.s1AddCampaignOpen = true;
    },

    async s1SubmitCampaign() {
      if (!this.s1CampaignForm.name) {
        this.s1CampaignFormError = "Campaign name is required.";
        return;
      }
      this.s1CampaignSaving = true;
      this.s1CampaignFormError = "";
      try {
        if (this.s1EditCampaign) {
          await apiPost("/admin/campaigns/" + this.s1EditCampaign.id, this.s1CampaignForm);
          Object.assign(this.s1EditCampaign, this.s1CampaignForm);
        } else {
          const res = await apiPost("/admin/campaigns/new", this.s1CampaignForm);
          const created = (res.data && res.data.data) || res.data;
          if (created) this.s1Campaigns.push(created);
        }
        this.s1AddCampaignOpen = false;
        this.s1ShowToast(this.s1EditCampaign ? "Campaign updated" : "Campaign created");
      } catch (e) {
        this.s1CampaignFormError = "Failed to save campaign.";
      } finally {
        this.s1CampaignSaving = false;
      }
    },

    s1SourceLabel(src) {
      const map = { google: "Google", facebook: "FB", bing: "Bing", tiktok: "TikTok", organic: "Organic", referral: "Referral", other: "Other" };
      return map[src] || src || "—";
    },

    s1SaveCplSource(src) {
      this.s1ShowSaved();
      // No /settings/cpl backend route — persist locally
      try { localStorage.setItem('s1_cpl_' + src.key, src.cpl); } catch(e) {}
    },

    // ── Games permissions matrix ───────────────────────────────────────────
    s1OpenGamesMatrix() {
      this.s1GamesDrawerOpen = true;
      if (!this.s1PermUsers.length) this.s1LoadPermissions();
    },

    async s1LoadPermissions() {
      this.s1GamesLoading = true;
      try {
        const res = await apiGet("/users/games/perm/user/all");
        if (res && res.data) {
          const records = Array.isArray(res.data) ? res.data : (res.data.users || res.data.data || []);
          this.s1PermUserRecords = records;
          // Extract unique users from records (same pattern as old UsersTable)
          const userMap = {};
          records.forEach(r => {
            const uid = r.user_id;
            if (uid && !userMap[uid]) {
              userMap[uid] = {
                id: uid,
                user_id: uid,
                first_name: r.user ? r.user.first_name : (r.first_name || 'User'),
                last_name: r.user ? r.user.last_name : (r.last_name || ''),
                email: r.user ? r.user.email : (r.email || ''),
                role: r.user ? r.user.role : (r.role || 4)
              };
            }
            // Build permission map from records
            if (uid && r.id && r.active) {
              this.$set(this.s1Permissions, uid + "_" + r.id, true);
            }
          });
          const uniqueUsers = Object.values(userMap);
          if (uniqueUsers.length > 0) {
            this.s1PermUsers = uniqueUsers;
          } else if (res.data.users) {
            this.s1PermUsers = res.data.users;
          } else {
            this.s1PermUsers = records;
          }
          // If server returned structured permissions or limits
          if (res.data.permissions) {
            const map = {};
            res.data.permissions.forEach(p => { map[p.user_id + "_" + p.game_id] = true; });
            this.s1Permissions = map;
          }
          if (res.data.limits) {
            const lmap = {};
            res.data.limits.forEach(l => { lmap[l.user_id] = l.daily_minutes; });
            this.s1GameLimits = lmap;
          }
        }
      } catch (e) {
        const list = this.$store.state.clients && this.$store.state.clients.salesPersonList;
        if (list && list.length) this.s1PermUsers = list.slice(0, 30);
      } finally {
        this.s1GamesLoading = false;
      }
    },

    s1HasPerm(userId, gameId) {
      return !!this.s1Permissions[userId + "_" + gameId];
    },

    async s1TogglePerm(userId, gameId) {
      const key = userId + "_" + gameId;
      const current = !!this.s1Permissions[key];
      this.$set(this.s1Permissions, key, !current);
      this.s1ShowSaved();
      try {
        await apiPut("/users/games/perm/user/" + userId, {
          user_id: userId,
          game_id: gameId,
          active: !current ? 1 : 0,
        });
      } catch (e) {
        this.$set(this.s1Permissions, key, current);
      }
    },

    async s1SetGameLimit(userId, value) {
      this.$set(this.s1GameLimits, userId, parseInt(value) || 60);
      this.s1ShowSaved();
      apiPut("/users/games/perm/user/" + userId, { daily_minutes: this.s1GameLimits[userId] }).catch(() => {});
    },

    s1GameEnabledCount(gameId) {
      return this.s1PermUsers.filter(u => this.s1HasPerm(u.id, gameId)).length;
    },

    s1GameEnabledPct(gameId) {
      if (!this.s1PermUsers.length) return 0;
      return Math.round((this.s1GameEnabledCount(gameId) / this.s1PermUsers.length) * 100);
    },

    async s1GrantAllGames(userId) {
      for (const game of this.s1Games) {
        const key = userId + "_" + game.id;
        if (!this.s1Permissions[key]) {
          this.$set(this.s1Permissions, key, true);
          apiPut("/users/games/perm/user/" + userId, { game_id: game.id, active: 1 }).catch(() => {});
        }
      }
      this.s1ShowSaved();
    },

    async s1RevokeAllGames(userId) {
      for (const game of this.s1Games) {
        const key = userId + "_" + game.id;
        if (this.s1Permissions[key]) {
          this.$set(this.s1Permissions, key, false);
          apiPut("/users/games/perm/user/" + userId, { game_id: game.id, active: 0 }).catch(() => {});
        }
      }
      this.s1ShowSaved();
    },

    // ── Deposit Goals ─────────────────────────────────────────────────────
    async s1LoadGoals() {
      this.s1GoalHistoryLoading = true;
      try {
        const [daily, weekly, monthly] = await Promise.all([
          apiGet("/admin/settings/deposits/goal/daily").catch(() => null),
          apiGet("/admin/settings/deposits/goal/weekly").catch(() => null),
          apiGet("/admin/settings/deposits/goal/monthly").catch(() => null),
        ]);
        if (daily && daily.data && daily.data !== "") {
          this.s1GoalDailyObj = daily.data;
          this.s1Goals.daily_target = daily.data.goal_count || 0;
          this.s1GoalDailyInput = daily.data.goal_count || 0;
        }
        if (weekly && weekly.data && weekly.data !== "") {
          this.s1GoalWeeklyObj = weekly.data;
          this.s1Goals.weekly_target = weekly.data.goal_count || 0;
          this.s1GoalWeeklyInput = weekly.data.goal_count || 0;
        }
        if (monthly && monthly.data && monthly.data !== "") {
          this.s1GoalMonthlyObj = monthly.data;
          this.s1Goals.monthly_target = monthly.data.goal_count || 0;
          this.s1GoalMonthlyInput = monthly.data.goal_count || 0;
        }
        // Build goal history from the three results
        this.s1GoalHistory = [];
        if (daily && daily.data && daily.data !== "") this.s1GoalHistory.push({ ...daily.data, goal_type: 'DAILY' });
        if (weekly && weekly.data && weekly.data !== "") this.s1GoalHistory.push({ ...weekly.data, goal_type: 'WEEKLY' });
        if (monthly && monthly.data && monthly.data !== "") this.s1GoalHistory.push({ ...monthly.data, goal_type: 'MONTHLY' });
        this.s1GoalHistory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      } catch (e) { /* use defaults */ }
      this.s1GoalHistoryLoading = false;
    },

    async s1SaveDailyGoal() {
      if (!this.s1GoalDailyInput && this.s1GoalDailyInput !== 0) return;
      this.s1GoalSaving = true;
      try {
        await apiPost("/admin/settings/deposits/goal/new", { goal_count: this.s1GoalDailyInput, goal_type: "DAILY" });
        this.s1ShowToast("Daily goal updated");
        await this.s1LoadGoals();
      } catch (e) {
        this.s1ShowToast("Failed to save daily goal", "#ef4444");
      }
      this.s1GoalSaving = false;
    },

    async s1SaveWeeklyGoal() {
      if (!this.s1GoalWeeklyInput && this.s1GoalWeeklyInput !== 0) return;
      this.s1GoalSaving = true;
      try {
        await apiPost("/admin/settings/deposits/goal/new", { goal_count: this.s1GoalWeeklyInput, goal_type: "WEEKLY" });
        this.s1ShowToast("Weekly goal updated");
        await this.s1LoadGoals();
      } catch (e) {
        this.s1ShowToast("Failed to save weekly goal", "#ef4444");
      }
      this.s1GoalSaving = false;
    },

    async s1SaveMonthlyGoal() {
      if (!this.s1GoalMonthlyInput && this.s1GoalMonthlyInput !== 0) return;
      this.s1GoalSaving = true;
      try {
        await apiPost("/admin/settings/deposits/goal/new", { goal_count: this.s1GoalMonthlyInput, goal_type: "MONTH" });
        this.s1ShowToast("Monthly goal updated");
        await this.s1LoadGoals();
      } catch (e) {
        this.s1ShowToast("Failed to save monthly goal", "#ef4444");
      }
      this.s1GoalSaving = false;
    },

    s1FmtGoalDate(date) {
      if (!date) return '--';
      try { return new Date(date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }); }
      catch (e) { return date; }
    },

    s1GoalPct(current, target) {
      if (!target) return 0;
      return Math.min(100, Math.round((current / target) * 100));
    },

    async s1LoadGoalUsers() {
      this.s1GoalUsersLoading = true;
      try {
        if (!this.s1Users.length) await this.s1LoadUsers();
        this.s1GoalUsers = this.s1Users.filter(u => u.role === 4 || u.role === 5);
      } finally {
        this.s1GoalUsersLoading = false;
      }
    },

    s1SetAgentGoal(userId, value) {
      if (value === "" || value === null) {
        this.$delete(this.s1AgentGoals, userId);
      } else {
        this.$set(this.s1AgentGoals, userId, parseInt(value));
      }
      this.s1ShowSaved();
      apiPost("/admin/settings/deposits/goal/new", { user_id: userId, daily: this.s1AgentGoals[userId] || null }).catch(() => {});
    },

    s1UserNameById(uid) {
      const user = this.s1Users.find(u => String(u.id) === String(uid));
      return user ? (user.first_name + " " + user.last_name).trim() : "User #" + uid;
    },

    // ── System Logs ───────────────────────────────────────────────────────
    async s1LoadLogs() {
      // Load all three log types
      this.s1FetchSysLog();
      this.s1FetchClientLog();
      this.s1FetchTaskLog();
    },

    async s1FetchSysLog() {
      this.s1SysLogLoading = true;
      try {
        const res = await apiGet("/admin/user/systemLog?page=" + this.s1SysLogPage);
        if (res && res.data) {
          const d = Array.isArray(res.data) ? res.data[0] : res.data;
          this.s1SysLogData = (d && d.data) || (Array.isArray(res.data) ? res.data : []);
          if (d && d.current_page) this.s1SysLogPage = d.current_page;
        }
      } catch (e) { this.s1SysLogData = []; }
      this.s1SysLogLoading = false;
    },

    async s1FetchClientLog() {
      this.s1ClientLogLoading = true;
      try {
        const res = await apiGet("/admin/user/clientCronLog?page=" + this.s1ClientLogPage);
        if (res && res.data) {
          const d = Array.isArray(res.data) ? res.data[0] : res.data;
          this.s1ClientLogData = (d && d.data) || (Array.isArray(res.data) ? res.data : []);
          if (d && d.current_page) this.s1ClientLogPage = d.current_page;
        }
      } catch (e) { this.s1ClientLogData = []; }
      this.s1ClientLogLoading = false;
    },

    async s1FetchTaskLog() {
      this.s1TaskLogLoading = true;
      try {
        const res = await apiGet("/admin/user/taskCronLog?page=" + this.s1TaskLogPage);
        if (res && res.data) {
          const d = Array.isArray(res.data) ? res.data[0] : res.data;
          this.s1TaskLogData = (d && d.data) || (Array.isArray(res.data) ? res.data : []);
          if (d && d.current_page) this.s1TaskLogPage = d.current_page;
        }
      } catch (e) { this.s1TaskLogData = []; }
      this.s1TaskLogLoading = false;
    },

    s1ToggleSysLogSort() {
      this.s1SysLogSortOrder = this.s1SysLogSortOrder === 'asc' ? 'desc' : 'asc';
      this.s1SysLogPage = 1;
      this.s1FetchSysLogSorted();
    },

    async s1FetchSysLogSorted() {
      this.s1SysLogLoading = true;
      try {
        const res = await apiGet("/admin/user/systemLog/" + this.s1SysLogSortOrder + "/f");
        if (res && res.data) {
          const d = Array.isArray(res.data) ? res.data[0] : res.data;
          this.s1SysLogData = (d && d.data) || (Array.isArray(res.data) ? res.data : []);
          if (d && d.current_page) this.s1SysLogPage = d.current_page;
        }
      } catch (e) { /* keep current data */ }
      this.s1SysLogLoading = false;
    },

    s1RefreshAllLogs() {
      this.s1SysLogPage = 1;
      this.s1ClientLogPage = 1;
      this.s1TaskLogPage = 1;
      this.s1LoadLogs();
    },

    s1TruncateLog(text, maxLen) {
      if (!text) return 'NO-STAT';
      return text.length > maxLen ? text.substr(0, maxLen) + '...' : text;
    },

    s1FmtLogTime(ts) {
      if (!ts) return "—";
      try {
        const d = new Date(ts);
        return d.toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
      } catch (e) { return ts; }
    },

    // ── CRM Config ───────────────────────────────────────────────────────
    s1SaveStatusTags() {
      this.s1ShowSaved();
      // No /settings/status_tags backend route — persist locally
      try { localStorage.setItem('s1_status_tags', JSON.stringify(this.s1StatusTags)); } catch(e) {}
    },

    s1SaveCountryTiers() {
      this.s1ShowSaved();
      // No /settings/country_tiers backend route — persist locally
      try { localStorage.setItem('s1_country_tiers', JSON.stringify(this.s1CountryTiers)); } catch(e) {}
    },

    // ── API Keys ───────────────────────────────────────────────────────────
    s1MaskKey(value) {
      if (!value) return "—";
      return value.slice(0, 10) + "••••••••••••" + value.slice(-4);
    },

    async s1CopyKey(value) {
      if (navigator.clipboard) await navigator.clipboard.writeText(value).catch(() => {});
      this.s1ShowToast("Copied to clipboard");
    },

    async s1GenerateKey() {
      if (!this.s1NewKeyName) return;
      this.s1ApiGenerating = true;
      this.s1NewKeyRevealed = null;
      try {
        const res = await apiPost("/consumers/getapikey", { name: this.s1NewKeyName });
        const newKey = {
          id:      (res && res.data && res.data.id) || Date.now(),
          name:    this.s1NewKeyName,
          value:   (res && res.data && res.data.key) || ("gnm_live_" + Math.random().toString(36).slice(2, 18)),
          created: new Date().toLocaleDateString("en-GB", { month: "short", year: "numeric" })
        };
        this.s1ApiKeys.push(newKey);
        this.s1NewKeyRevealed = newKey.value;
        this.s1NewKeyName = "";
        setTimeout(() => { this.s1NewKeyRevealed = null; }, 30000);
      } catch (e) {
        const mockKey = "gnm_live_" + Math.random().toString(36).slice(2, 18);
        this.s1ApiKeys.push({ id: Date.now(), name: this.s1NewKeyName, value: mockKey, created: new Date().toLocaleDateString("en-GB", { month: "short", year: "numeric" }) });
        this.s1NewKeyRevealed = mockKey;
        this.s1NewKeyName = "";
        setTimeout(() => { this.s1NewKeyRevealed = null; }, 30000);
      } finally {
        this.s1ApiGenerating = false;
      }
    },

    async s1RevokeKey(id) {
      const idx = this.s1ApiKeys.findIndex(k => k.id === id);
      if (idx === -1) return;
      const removed = this.s1ApiKeys.splice(idx, 1)[0];
      this.s1ShowSaved();
      try {
        // No /settings/api-keys DELETE backend route — key removed from local state only
        console.warn('[Settings1] API key revoke: no backend route available for id', id);
      } catch (e) {
        this.s1ApiKeys.splice(idx, 0, removed);
      }
    },

    // ── Billing ──────────────────────────────────────────────────────────
    s1SelectPlan(plan) {
      if (!window.confirm) {
        this.s1Settings.plan = plan.key;
        this.s1AutoSave("plan");
        return;
      }
      if (confirm("Switch to " + plan.label + " plan?")) {
        this.s1Settings.plan = plan.key;
        this.s1AutoSave("plan");
        this.s1ShowToast("Plan updated to " + plan.label);
      }
    },

    // ── Helpers ───────────────────────────────────────────────────────────
    s1UserIni(user) {
      return (((user.first_name || "")[0] || "").toUpperCase() + ((user.last_name || "")[0] || "").toUpperCase()) || "?";
    },

    s1AvatarColor(id) {
      const colors = ["#6366f1","#a855f7","#22c55e","#f59e0b","#ef4444","#3b82f6","#06b6d4","#ec4899"];
      return colors[id % colors.length];
    },

    // ── Viopa AI ───────────────────────────────────────────────────────────
    sec1ViopaKeyLabel(key) {
      const map = {
        country_match:   'Country Match Weight',
        country:         'Country Match Weight',
        campaign_match:  'Campaign Match Weight',
        campaign:        'Campaign Match Weight',
        keyword_match:   'Keyword Match Weight',
        keyword:         'Keyword Match Weight',
        language_match:  'Language Match Weight',
        language:        'Language Match Weight',
        age_match:       'Age Match Weight',
        age:             'Age Match Weight',
        deposit_history: 'Deposit History Weight',
        deposits:        'Deposit History Weight',
        recency:         'Recency Weight',
        frequency:       'Frequency Weight',
        score_boost:     'Score Boost',
        boost:           'Score Boost',
        penalty:         'Penalty Weight',
        base_score:      'Base Score',
      };
      if (map[key]) return map[key];
      // Auto-format snake_case to Title Case
      return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    },

    async sec1LoadViopa() {
      this.sec1ViopaLoading = true;
      try {
        const h = authHeaders();
        const [s, t] = await Promise.all([
          fetch(this.$store.getters.getServerPath + '/admin/viopa/score', { headers: h }),
          fetch(this.$store.getters.getServerPath + '/admin/viopa/transfer-score', { headers: h })
        ]);
        this.sec1ViopaScore = await s.json().catch(() => null);
        this.sec1ViopaTransfer = await t.json().catch(() => null);
      } catch(e) {}
      this.sec1ViopaLoading = false;
    },

    // ── Timezone clock ─────────────────────────────────────────────────────
    s1TickClock() {
      const fmtTz = (tz) => {
        try { return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz }); }
        catch (e) { return "--:--"; }
      };
      this.s1TimeUK = fmtTz("Europe/London");
      this.s1TimeIL = fmtTz("Asia/Jerusalem");
    }
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) {
      sessionStorage.removeItem('c1keepNav');
      this.s1SlideOpen = 'nav';
      this.c1NavMode = 'panels';
    }
    sessionStorage.removeItem('c1openPanel');
  },

  mounted() {
    document.documentElement.style.setProperty('--gnm-sw', '0px');
    this.s1TickClock();
    this.s1Clock = setInterval(this.s1TickClock, 30000);
    this.s1FetchSettings();
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
  },

  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
    if (this.s1Clock) clearInterval(this.s1Clock);
    if (this.s1SavedTimer) clearTimeout(this.s1SavedTimer);
    if (this.s1ToastTimer) clearTimeout(this.s1ToastTimer);
  }
};
</script>

<style scoped>
/* ────────────────────────────────────────────────────────────────
   SETTINGS1 — full dark design system
   bg: #0a0a0f  surface: #13131a  border: #1e1e2e  accent: #6366f1
──────────────────────────────────────────────────────────────────*/
.s1-main {
  --c1-bg:       #f4f3f0;
  --c1-surface:  #ffffff;
  --c1-surface2: #f4f3f0;
  --c1-border:   #e4e3df;
  --c1-text:     #1a1a1a;
  --c1-muted:    #64748b;
  /* Aliases so shared c1-design.css panel CSS resolves correctly */
  --c1-card:  #ffffff;
  --c1-brd:   #e4e3df;
  --c1-brd-l: #eeedea;
  --c1-t1:    #1a1a1a;
  --c1-t2:    #64748b;
  --c1-t3:    #94a3b8;
  --c1-accent:   #6366f1;
  --c1-accent2:  #8b5cf6;
  --c1-dp:       #22c55e;
  --c1-ld:       #f59e0b;
  --c1-na:       #ef4444;
  --c1-sc:       #3b82f6;
  --c1-rf:       #a855f7;
  --s1-bg:       var(--c1-bg);
  --s1-surf:     var(--c1-surface);
  --s1-surf2:    #f4f3f0;
  --s1-brd:      var(--c1-border);
  --s1-brd-l:    #eeedea;
  --s1-t1:       var(--c1-text);
  --s1-t2:       #6b6963;
  --s1-t3:       #a09e98;
  --s1-ac:       var(--c1-accent);
  --s1-ac-h:     #4f51d0;
  --s1-ac-bg:    rgba(99,102,241,.12);
  --s1-green:    var(--c1-dp);
  --s1-red:      var(--c1-na);
  --s1-warn:     var(--c1-ld);
  font-family: 'DM Sans', -apple-system, sans-serif;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding-left: var(--gnm-sw, 220px);
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
@media (max-width: 767px) {
  .s1-main { padding-left: 0 !important; }
}

/* ── TOAST ── */
.sg1-toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  z-index: 99999; padding: 10px 22px; border-radius: 24px; color: #fff; font-size: .85rem; font-weight: 600;
  box-shadow: 0 4px 20px rgba(0,0,0,.25); pointer-events: none; white-space: nowrap;
  height: auto; display: inline-flex; align-items: center;
}
.sg1-toast-fade-enter-active, .sg1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.sg1-toast-fade-enter, .sg1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ── TOPBAR ── */
.c1-tib {
  display: flex; align-items: center; gap: 2px;
  padding: 0 12px; height: 46px;
  border-bottom: 1px solid var(--s1-brd);
  background: var(--s1-surf);
  flex-shrink: 0; position: sticky; top: 0; z-index: 150;
}
.c1-tib-btn {
  display: flex; flex-direction: column; align-items: center; gap: 2px;
  padding: 5px 10px; border-radius: 8px; cursor: pointer;
  color: var(--s1-t2); font-size: 9px; font-weight: 600;
  letter-spacing: .3px; text-transform: uppercase;
  transition: background .15s, color .15s;
}
.c1-tib-btn svg { width: 15px; height: 15px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.c1-tib-btn:hover { background: rgba(0,0,0,.04); color: var(--s1-t1); }
.c1-tib-btn.on { background: var(--s1-ac-bg); color: var(--s1-ac); }
.c1-tib-btn.on svg { stroke: var(--s1-ac); }
.c1-tib-user {
  position: relative; width: 32px; height: 32px; border-radius: 50%;
  background: var(--s1-ac); display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: opacity .15s; flex-shrink: 0;
}
.c1-tib-user:hover { opacity: .85; }
.c1-tib-user.on { box-shadow: 0 0 0 2px var(--s1-ac); }
.c1-tib-ini { font-size: 11px; font-weight: 700; color: #fff; letter-spacing: -.3px; line-height: 1; }
.c1-tib-udot {
  position: absolute; bottom: 0; right: 0;
  width: 9px; height: 9px; border-radius: 50%;
  border: 2px solid var(--s1-surf); background: var(--s1-t3);
}
.c1-tib-udot.online { background: var(--s1-green); }
.c1-hp { flex: 1; }

/* ── FILTER PANEL ── */
.s1-panel {
  background: var(--s1-surf); border-bottom: 1px solid var(--s1-brd);
  flex-shrink: 0; max-height: 0; overflow: hidden; -webkit-overflow-scrolling: touch;
  transition: max-height .25s cubic-bezier(.4,0,.2,1);
}
.s1-panel.c1-panel--open {
  max-height: 60vh; overflow-y: auto;
}
.s1-sl-body { padding: 12px 14px 4px; }
.s1-fp-group { margin-bottom: 14px; }
.s1-fp-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: var(--s1-t3); margin-bottom: 8px; }
.s1-fp-opts { display: flex; flex-wrap: wrap; gap: 6px; }
.s1-fp-opt {
  padding: 5px 12px; border-radius: 20px; border: 1px solid var(--s1-brd);
  font-size: 11px; font-weight: 600; color: var(--s1-t2); cursor: pointer; transition: all .12s;
}
.s1-fp-opt:hover { border-color: var(--s1-ac); color: var(--s1-t1); }
.s1-fp-opt.on { background: var(--s1-ac-bg); border-color: var(--s1-ac); color: var(--s1-ac); }
.s1-collapse-bar {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 10px; cursor: pointer; color: var(--s1-t3); font-size: 11px;
  border-top: 1px solid var(--s1-brd); transition: color .15s;
}
.s1-collapse-bar:hover { color: var(--s1-t1); }
.s1-collapse-bar svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

/* ── PROFILE PANEL ── */
.s1-prof-panel {
  background: var(--s1-surf); border-bottom: 1px solid var(--s1-brd);
  flex-shrink: 0; max-height: 0; overflow: hidden;
  transition: max-height .25s cubic-bezier(.4,0,.2,1);
}
.s1-prof-panel.c1-panel--open {
  max-height: 80vh; overflow-y: auto;
}
.s1-prof-head { padding: 14px; border-bottom: 1px solid var(--s1-brd); }
.s1-prof-brand-row { display: flex; align-items: center; margin-bottom: 10px; }
.s1-prof-brand-name { font-size: 14px; font-weight: 800; letter-spacing: -.4px; color: var(--s1-t1); }
.s1-prof-brand-name span { color: var(--s1-ac); }
.s1-tz-row { display: flex; gap: 8px; }
.s1-tz { display: flex; flex-direction: column; align-items: center; gap: 1px; }
.s1-tz-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; color: var(--s1-t3); }
.s1-tz-t { font-size: 12px; font-weight: 600; color: var(--s1-t2); }
.s1-prof-user-row { display: flex; align-items: center; gap: 10px; }
.s1-prof-av {
  width: 38px; height: 38px; border-radius: 50%; background: var(--s1-ac);
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.s1-prof-meta { flex: 1; min-width: 0; }
.s1-prof-name { font-size: 13px; font-weight: 600; color: var(--s1-t1); }
.s1-prof-role { font-size: 11px; color: var(--s1-t3); margin-top: 1px; }
.s1-prof-toggle {
  display: flex; align-items: center; gap: 5px; padding: 5px 10px;
  border-radius: 16px; border: 1px solid var(--s1-brd-l); cursor: pointer;
  font-size: 10px; font-weight: 600; color: var(--s1-t3); transition: all .15s;
}
.s1-prof-toggle.online { border-color: rgba(34,197,94,.4); color: var(--s1-green); }
.s1-prof-tog-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--s1-t3); transition: background .15s; }
.s1-prof-toggle.online .s1-prof-tog-dot { background: var(--s1-green); }
.s1-prof-scroll { padding: 12px 14px; }
.s1-nc-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: var(--s1-t3); margin-bottom: 6px; }
.s1-ng { display: flex; flex-direction: column; gap: 2px; }
.s1-nb {
  display: flex; align-items: center; gap: 10px;
  padding: 9px 10px; border-radius: 8px; cursor: pointer;
  color: var(--s1-t2); font-size: 12px; font-weight: 500;
  text-decoration: none; transition: background .12s, color .12s;
}
.s1-nb svg { width: 15px; height: 15px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.s1-nb:hover, .s1-nb.router-link-active { background: var(--s1-ac-bg); color: var(--s1-t1); }
.s1-nb-logout:hover { background: rgba(239,68,68,.12); color: var(--s1-red); }

/* ── DRAWERS ── */
.s1-drawer-wrap {
  position: fixed; inset: 0; background: rgba(0,0,0,.55); z-index: 500;
  display: flex; justify-content: flex-end;
}
.s1-drawer-wrap-wide { justify-content: flex-end; }
.s1-drawer {
  width: min(420px, 100vw); height: 100vh; background: var(--s1-surf);
  display: flex; flex-direction: column; overflow: hidden;
  border-left: 1px solid var(--s1-brd);
}
.s1-drawer-wide { width: min(680px, 100vw); }
.s1-drawer-enter-active, .s1-drawer-leave-active { transition: opacity .2s; }
.s1-drawer-enter .s1-drawer, .s1-drawer-leave-to .s1-drawer { transform: translateX(40px); opacity: 0; }
.s1-drawer-enter-active .s1-drawer, .s1-drawer-leave-active .s1-drawer { transition: transform .22s ease, opacity .22s; }
.s1-drawer-head {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 16px; border-bottom: 1px solid var(--s1-brd);
  flex-shrink: 0; background: var(--s1-surf2);
}
.s1-drawer-head svg { width: 16px; height: 16px; stroke: var(--s1-ac); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.s1-drawer-title { flex: 1; font-size: 14px; font-weight: 700; color: var(--s1-t1); }
.s1-drawer-close {
  width: 28px; height: 28px; border-radius: 6px; border: none;
  background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center;
  color: var(--s1-t3); transition: background .12s, color .12s;
}
.s1-drawer-close:hover { background: rgba(0,0,0,.04); color: var(--s1-t1); }
.s1-drawer-close svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-drawer-body { flex: 1; overflow-y: auto; padding: 16px; -webkit-overflow-scrolling: touch; }

/* ── FORMS ── */
.s1-form-row { margin-bottom: 14px; }
.s1-form-row-toggle { display: flex; align-items: center; justify-content: space-between; }
.s1-form-lbl { display: block; font-size: 11px; font-weight: 600; color: var(--s1-t3); margin-bottom: 5px; text-transform: uppercase; letter-spacing: .3px; }
.s1-form-input {
  width: 100%; padding: 8px 10px; border-radius: 8px;
  background: var(--s1-bg); border: 1px solid var(--s1-brd);
  color: var(--s1-t1); font-size: 13px; font-family: inherit;
  outline: none; transition: border-color .15s; box-sizing: border-box;
}
.s1-form-input:focus { border-color: var(--s1-ac); }
.s1-form-input:disabled { opacity: .4; cursor: not-allowed; }
.s1-form-select {
  width: 100%; padding: 8px 10px; border-radius: 8px;
  background: var(--s1-bg); border: 1px solid var(--s1-brd);
  color: var(--s1-t1); font-size: 13px; font-family: inherit;
  outline: none; transition: border-color .15s; appearance: none;
}
.s1-form-select:focus { border-color: var(--s1-ac); }
.s1-form-err { font-size: 12px; color: var(--s1-red); margin-bottom: 10px; padding: 7px 10px; background: rgba(239,68,68,.1); border-radius: 6px; }
.s1-form-actions { display: flex; gap: 8px; justify-content: flex-end; margin-top: 20px; }

/* ── BUTTONS ── */
.s1-btn-primary {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: 8px; border: none;
  background: var(--s1-ac); color: #fff; font-size: 12px; font-weight: 600;
  cursor: pointer; transition: background .15s; font-family: inherit;
}
.s1-btn-primary:hover { background: var(--s1-ac-h); }
.s1-btn-primary:disabled { opacity: .5; cursor: not-allowed; }
.s1-btn-primary svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.s1-btn-ghost {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: 8px; border: 1px solid var(--s1-brd);
  background: transparent; color: var(--s1-t2); font-size: 12px; font-weight: 600;
  cursor: pointer; transition: all .15s; font-family: inherit;
}
.s1-btn-ghost:hover { background: rgba(0,0,0,.04); color: var(--s1-t1); }
.s1-btn-ghost:disabled { opacity: .4; cursor: not-allowed; }

/* ── MAIN CONTENT ── */
.s1-content { flex: 1; padding: 0 0 80px; overflow-y: visible; }

/* ── PAGE HEADER ── */
.s1-page-hdr {
  display: flex; align-items: center; gap: 14px;
  padding: 18px 16px 14px;
}
.s1-page-hdr-icon {
  width: 40px; height: 40px; border-radius: 10px;
  background: var(--s1-ac-bg); display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.s1-page-hdr-icon svg { width: 18px; height: 18px; stroke: var(--s1-ac); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-page-title { font-size: 18px; font-weight: 800; color: var(--s1-t1); letter-spacing: -.4px; }
.s1-page-sub { font-size: 12px; color: var(--s1-t3); margin-top: 2px; }

/* ── SAVED TOAST ── */
.s1-saved-toast {
  position: fixed; top: 12px; right: 16px; z-index: 9000;
  background: #f0fdf4; border: 1px solid rgba(34,197,94,.3);
  color: #16a34a; padding: 7px 14px; border-radius: 8px;
  font-size: 12px; font-weight: 600; display: flex; align-items: center; gap: 6px; pointer-events: none;
}
.s1-saved-toast svg { width: 13px; height: 13px; stroke: #16a34a; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.s1-saved-enter-active, .s1-saved-leave-active { transition: opacity .2s, transform .2s; }
.s1-saved-enter, .s1-saved-leave-to { opacity: 0; transform: translateY(-4px); }

/* ── CARD GRID ── */
.s1-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px; padding: 0 14px 20px;
}
.s1-cat-card {
  background: var(--s1-surf); border: 1px solid var(--s1-brd);
  border-radius: 12px; padding: 16px 14px; cursor: pointer;
  transition: border-color .15s, background .15s; position: relative;
}
.s1-cat-card:hover { background: var(--s1-surf2); border-color: var(--s1-brd-l); }
.s1-cat-card.active { border-color: var(--s1-ac); background: var(--s1-ac-bg); }
.s1-cat-card-icon {
  width: 36px; height: 36px; border-radius: 9px;
  display: flex; align-items: center; justify-content: center; margin-bottom: 10px;
}
.s1-cat-card-icon svg { width: 17px; height: 17px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-cat-card-label { font-size: 12px; font-weight: 700; color: var(--s1-t1); margin-bottom: 3px; }
.s1-cat-card-desc { font-size: 10px; color: var(--s1-t3); line-height: 1.4; }
.s1-cat-card-arrow {
  position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
  width: 14px; height: 14px; stroke: var(--s1-t3); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;
  opacity: 0; transition: opacity .15s;
}
.s1-cat-card:hover .s1-cat-card-arrow, .s1-cat-card.active .s1-cat-card-arrow { opacity: 1; }

/* ── SECTION PANEL ── */
.s1-section {
  margin: 0 14px 24px; background: var(--s1-surf);
  border: 1px solid var(--s1-brd); border-radius: 12px; overflow: hidden;
}
.s1-section-hdr {
  display: flex; align-items: center; gap: 10px;
  padding: 16px 18px; border-bottom: 1px solid var(--s1-brd);
  background: var(--s1-surf2); flex-wrap: wrap;
}
.s1-section-title { font-size: 15px; font-weight: 800; color: var(--s1-t1); letter-spacing: -.3px; }
.s1-section-sub { font-size: 11px; color: var(--s1-t3); margin-top: 2px; flex-basis: 100%; }
.s1-section-action { margin-left: auto; }

/* ── TABLE ── */
.s1-table-toolbar {
  display: flex; align-items: center; gap: 8px;
  padding: 12px 16px; border-bottom: 1px solid var(--s1-brd);
}
.s1-search-wrap { flex: 1; position: relative; }
.s1-search-wrap svg { position: absolute; left: 9px; top: 50%; transform: translateY(-50%); width: 13px; height: 13px; stroke: var(--s1-t3); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-search-input { width: 100%; padding: 7px 10px 7px 30px; border-radius: 8px; background: var(--s1-bg); border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 12px; font-family: inherit; outline: none; box-sizing: border-box; transition: border-color .15s; }
.s1-search-input:focus { border-color: var(--s1-ac); }
.s1-tbar-sel { padding: 6px 10px; border-radius: 8px; background: var(--s1-bg); border: 1px solid var(--s1-brd); color: var(--s1-t2); font-size: 12px; font-family: inherit; outline: none; }
.s1-table-wrap { overflow-x: auto; }
.s1-table { width: 100%; border-collapse: collapse; }
.s1-table thead tr { border-bottom: 1px solid var(--s1-brd); }
.s1-table th { padding: 9px 14px; text-align: left; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--s1-t3); white-space: nowrap; }
.s1-table-row { border-bottom: 1px solid var(--s1-brd); transition: background .1s; cursor: default; }
.s1-table-row:hover { background: rgba(0,0,0,.04); }
.s1-table td { padding: 10px 14px; font-size: 12px; color: var(--s1-t1); vertical-align: middle; }
.s1-td-muted { color: var(--s1-t3) !important; }
.s1-td-bold { font-weight: 600; }
.s1-td-sm { font-size: 11px !important; }
.s1-pt-empty { text-align: center; color: var(--s1-t3); font-size: 12px; padding: 24px !important; }

/* ── USER CELL ── */
.s1-user-cell { display: flex; align-items: center; gap: 9px; }
.s1-user-av {
  width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 700; color: #fff;
}
.s1-user-name-wrap {}
.s1-user-full-name { font-size: 12px; font-weight: 600; color: var(--s1-t1); }
.s1-user-ext { font-size: 10px; color: var(--s1-t3); }

/* ── ROLE BADGES ── */
.s1-role-badge { display: inline-block; padding: 3px 8px; border-radius: 5px; font-size: 10px; font-weight: 700; letter-spacing: .2px; }
.s1-role-1  { background: rgba(239,68,68,.15);   color: #ef4444; }
.s1-role-2  { background: rgba(168,85,247,.15);  color: #a855f7; }
.s1-role-3  { background: rgba(59,130,246,.15);  color: #3b82f6; }
.s1-role-4  { background: rgba(34,197,94,.15);   color: #22c55e; }
.s1-role-5  { background: rgba(245,158,11,.15);  color: #f59e0b; }
.s1-role-12 { background: rgba(239,68,68,.2);    color: #ff6060; }

/* ── ROLE GRID ── */
.s1-role-grid { display: flex; flex-wrap: wrap; gap: 8px; padding: 14px 16px; }
.s1-role-card { display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: var(--s1-bg); border: 1px solid var(--s1-brd); border-radius: 8px; }
.s1-role-desc { font-size: 11px; color: var(--s1-t3); }

/* ── ROW EDIT BTN ── */
.s1-row-edit-btn {
  padding: 5px 7px; border-radius: 6px; border: 1px solid var(--s1-brd);
  background: transparent; cursor: pointer; color: var(--s1-t3); transition: all .12s;
}
.s1-row-edit-btn:hover { background: var(--s1-ac-bg); color: var(--s1-ac); border-color: var(--s1-ac); }
.s1-row-edit-btn svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; display: block; }

/* ── BROKER ── */
.s1-broker-cell { display: flex; align-items: center; gap: 9px; }
.s1-broker-av {
  width: 30px; height: 30px; border-radius: 8px; background: var(--s1-surf2);
  border: 1px solid var(--s1-brd); display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 700; color: var(--s1-t2); flex-shrink: 0;
}
.s1-broker-name { font-size: 12px; font-weight: 600; color: var(--s1-t1); }
.s1-cpa-badge { display: inline-block; padding: 3px 8px; border-radius: 5px; font-size: 11px; font-weight: 700; background: rgba(34,197,94,.12); color: var(--s1-green); }

/* ── CAMPAIGNS CPL ── */
.s1-cpl-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 8px; padding: 0 16px; }
.s1-cpl-card { background: var(--s1-bg); border: 1px solid var(--s1-brd); border-radius: 8px; padding: 12px 10px; text-align: center; }
.s1-cpl-source { font-size: 11px; font-weight: 600; color: var(--s1-t2); margin-bottom: 6px; }
.s1-cpl-val-wrap { display: flex; align-items: center; justify-content: center; gap: 2px; }
.s1-cpl-prefix { font-size: 11px; color: var(--s1-t3); }
.s1-cpl-input { width: 60px; text-align: center; padding: 4px 6px; border-radius: 6px; background: var(--s1-surf); border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 14px; font-weight: 700; font-family: inherit; outline: none; }
.s1-cpl-input:focus { border-color: var(--s1-ac); }
.s1-cpl-unit { font-size: 10px; color: var(--s1-t3); margin-top: 4px; }
.s1-source-badge { display: inline-block; padding: 2px 7px; border-radius: 4px; font-size: 10px; font-weight: 700; background: rgba(99,102,241,.12); color: var(--s1-ac); }

/* ── GAMES SUMMARY ── */
.s1-games-summary-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 8px; padding: 16px; }
.s1-game-summary-card { background: var(--s1-bg); border: 1px solid var(--s1-brd); border-radius: 10px; padding: 12px; }
.s1-game-ico { margin-bottom: 6px; }
.s1-game-ico svg { width: 18px; height: 18px; stroke: var(--s1-ac); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-game-name { font-size: 12px; font-weight: 700; color: var(--s1-t1); margin-bottom: 2px; }
.s1-game-stat { font-size: 10px; color: var(--s1-t3); margin-bottom: 6px; }
.s1-game-progress { height: 3px; background: var(--s1-brd); border-radius: 99px; overflow: hidden; }
.s1-game-progress-bar { height: 100%; background: var(--s1-ac); border-radius: 99px; transition: width .3s; }

/* ── PERMISSION TABLE ── */
.s1-perm-table-wrap { overflow-x: auto; }
.s1-perm-table { width: 100%; border-collapse: collapse; }
.s1-perm-table thead tr { border-bottom: 1px solid var(--s1-brd); }
.s1-perm-table th { padding: 8px 10px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: var(--s1-t3); text-align: center; white-space: nowrap; }
.s1-pt-user-col { text-align: left; min-width: 160px; }
.s1-pt-game-col { min-width: 80px; }
.s1-perm-table tbody tr { border-bottom: 1px solid var(--s1-brd); }
.s1-perm-table tbody tr:hover { background: rgba(0,0,0,.04); }
.s1-pt-user-cell { padding: 8px 10px; display: flex; align-items: center; gap: 8px; }
.s1-pt-user-av {
  width: 28px; height: 28px; border-radius: 50%; background: var(--s1-ac);
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.s1-pt-user-info { display: flex; flex-direction: column; }
.s1-pt-user-name { font-size: 12px; font-weight: 600; color: var(--s1-t1); }
.s1-pt-user-role { font-size: 10px; color: var(--s1-t3); }
.s1-pt-toggle-cell { padding: 8px 10px; text-align: center; vertical-align: middle; }
.s1-perm-toggle {
  display: inline-flex; width: 32px; height: 18px; border-radius: 99px;
  background: var(--s1-brd); position: relative; cursor: pointer; transition: background .15s;
}
.s1-perm-toggle.on { background: var(--s1-ac); }
.s1-perm-dot {
  width: 12px; height: 12px; border-radius: 50%; background: #fff;
  position: absolute; top: 3px; left: 3px; transition: left .15s;
}
.s1-perm-toggle.on .s1-perm-dot { left: 17px; }
.s1-pt-limit-wrap { display: flex; align-items: center; gap: 4px; justify-content: center; }
.s1-pt-limit-input { width: 48px; text-align: center; padding: 4px 4px; border-radius: 6px; background: var(--s1-bg); border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 12px; font-family: inherit; outline: none; }
.s1-pt-limit-wide { width: 64px; }
.s1-pt-limit-input:focus { border-color: var(--s1-ac); }
.s1-pt-limit-unit { font-size: 10px; color: var(--s1-t3); }
.s1-perm-info-bar { background: rgba(99,102,241,.08); border: 1px solid rgba(99,102,241,.2); border-radius: 8px; padding: 9px 12px; font-size: 11px; color: var(--s1-t2); margin-bottom: 14px; display: flex; align-items: center; gap: 7px; }
.s1-perm-info-bar svg { width: 13px; height: 13px; stroke: var(--s1-ac); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }

/* ── GOALS ── */
.s1-goals-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 10px; padding: 16px; }
.s1-goal-card { background: var(--s1-bg); border: 1px solid var(--s1-brd); border-radius: 10px; padding: 14px; }
.s1-goal-card-hdr { display: flex; align-items: center; gap: 7px; font-size: 12px; font-weight: 700; color: var(--s1-t2); margin-bottom: 10px; }
.s1-goal-card-hdr svg { width: 15px; height: 15px; stroke: var(--s1-ac); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-goal-input-wrap { display: flex; align-items: center; gap: 6px; margin-bottom: 10px; }
.s1-goal-input { width: 80px; padding: 6px 8px; border-radius: 7px; background: var(--s1-surf); border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 20px; font-weight: 800; font-family: inherit; outline: none; text-align: center; }
.s1-goal-input:focus { border-color: var(--s1-ac); }
.s1-goal-unit { font-size: 11px; color: var(--s1-t3); }
.s1-goal-progress-wrap {}
.s1-goal-progress-lbl { display: flex; justify-content: space-between; font-size: 10px; color: var(--s1-t3); margin-bottom: 4px; }
.s1-goal-bar { height: 4px; background: var(--s1-brd); border-radius: 99px; overflow: hidden; }
.s1-goal-bar-fill { height: 100%; background: var(--s1-ac); border-radius: 99px; transition: width .4s; }
.s1-goal-bar-month { background: var(--s1-green); }
.s1-goal-bar-week  { background: var(--s1-warn); }

.s1-subsection-hdr {
  font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px;
  color: var(--s1-t3); padding: 14px 16px 6px;
  display: flex; align-items: center; gap: 8px;
}
.s1-subsec-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 4px 10px; border-radius: 6px; border: 1px solid var(--s1-brd);
  background: transparent; color: var(--s1-t2); font-size: 11px; font-weight: 600;
  cursor: pointer; transition: all .12s; font-family: inherit;
}
.s1-subsec-btn:hover { background: var(--s1-ac-bg); color: var(--s1-ac); border-color: var(--s1-ac); }
.s1-subsec-btn svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-agent-goals-preview { display: flex; flex-wrap: wrap; gap: 6px; padding: 4px 16px 12px; }
.s1-agent-goal-chip { display: flex; align-items: center; gap: 6px; background: var(--s1-bg); border: 1px solid var(--s1-brd); border-radius: 8px; padding: 5px 10px; }
.s1-ag-name { font-size: 11px; color: var(--s1-t2); }
.s1-ag-val { font-size: 11px; font-weight: 700; color: var(--s1-ac); }

/* ── AGENT GOAL LIST (drawer) ── */
.s1-agent-goal-list { display: flex; flex-direction: column; gap: 2px; }
.s1-agent-goal-row {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 4px; border-bottom: 1px solid var(--s1-brd);
}
.s1-agent-goal-name { flex: 1; font-size: 12px; font-weight: 600; color: var(--s1-t1); }
.s1-agent-goal-ctrl { display: flex; align-items: center; gap: 5px; }

/* ── SYSTEM LOGS ── */
.s1-log-toolbar { display: flex; align-items: center; gap: 8px; padding: 12px 16px; border-bottom: 1px solid var(--s1-brd); flex-wrap: wrap; }
.s1-log-search { flex: 1; min-width: 120px; padding: 7px 10px; border-radius: 8px; background: var(--s1-bg); border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 12px; font-family: inherit; outline: none; }
.s1-log-search:focus { border-color: var(--s1-ac); }
.s1-log-filter-sel { padding: 6px 10px; border-radius: 8px; background: var(--s1-bg); border: 1px solid var(--s1-brd); color: var(--s1-t2); font-size: 12px; font-family: inherit; outline: none; }
.s1-log-refresh-btn svg { width: 13px; height: 13px; }
.s1-log-list { max-height: 480px; overflow-y: auto; }
.s1-log-list-inline { max-height: 400px; }
.s1-log-row { display: flex; align-items: flex-start; gap: 10px; padding: 9px 16px; border-bottom: 1px solid var(--s1-brd); transition: background .1s; }
.s1-log-row:hover { background: rgba(0,0,0,.04); }
.s1-log-dot { width: 7px; height: 7px; border-radius: 50%; margin-top: 4px; flex-shrink: 0; background: var(--s1-t3); }
.s1-log-info    .s1-log-dot { background: var(--s1-t3); }
.s1-log-login   .s1-log-dot { background: var(--s1-ac); }
.s1-log-deposit .s1-log-dot { background: var(--s1-green); }
.s1-log-user    .s1-log-dot { background: #a855f7; }
.s1-log-settings .s1-log-dot { background: var(--s1-warn); }
.s1-log-broker  .s1-log-dot { background: #3b82f6; }
.s1-log-error   .s1-log-dot { background: var(--s1-red); }
.s1-log-body { flex: 1; min-width: 0; }
.s1-log-msg { font-size: 12px; color: var(--s1-t1); margin-bottom: 3px; }
.s1-log-meta { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.s1-log-type-tag { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; padding: 2px 5px; border-radius: 4px; background: rgba(0,0,0,.05); color: var(--s1-t3); }
.s1-log-user { font-size: 10px; color: var(--s1-t3); }
.s1-log-time { font-size: 10px; color: var(--s1-t3); }

/* ── CRM CONFIG ── */
.s1-status-tag-grid { display: flex; flex-direction: column; gap: 0; padding: 0 16px; }
.s1-status-tag-row { display: flex; align-items: center; gap: 10px; padding: 8px 0; border-bottom: 1px solid var(--s1-brd); }
.s1-status-tag-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.s1-status-tag-name-wrap { flex: 1; }
.s1-status-tag-name-input { background: transparent; border: none; border-bottom: 1px solid transparent; color: var(--s1-t1); font-size: 12px; font-weight: 600; font-family: inherit; outline: none; width: 100%; transition: border-color .15s; }
.s1-status-tag-name-input:focus { border-bottom-color: var(--s1-ac); }
.s1-color-picker { width: 28px; height: 28px; border: 1px solid var(--s1-brd); border-radius: 6px; cursor: pointer; background: none; padding: 2px; }
.s1-tier-info-bar { font-size: 11px; color: var(--s1-t3); padding: 4px 16px 10px; }
.s1-tier-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; padding: 0 16px 16px; }
.s1-tier-card { background: var(--s1-bg); border: 1px solid var(--s1-brd); border-radius: 8px; padding: 10px; }
.s1-tier-label { font-size: 11px; font-weight: 800; letter-spacing: .4px; margin-bottom: 6px; }
.s1-tier-t1 .s1-tier-label { color: var(--s1-green); }
.s1-tier-t2 .s1-tier-label { color: var(--s1-warn); }
.s1-tier-t3 .s1-tier-label { color: var(--s1-t3); }
.s1-tier-textarea { width: 100%; background: transparent; border: none; color: var(--s1-t2); font-size: 11px; font-family: 'SF Mono', monospace; resize: vertical; outline: none; line-height: 1.6; box-sizing: border-box; }

/* ── SETTINGS ROW (generic) ── */
.s1-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 16px; border-bottom: 1px solid var(--s1-brd);
}
.s1-row-tall { align-items: flex-start; }
.s1-row-lbl { flex: 1; min-width: 0; padding-right: 16px; }
.s1-row-name { font-size: 13px; font-weight: 600; color: var(--s1-t1); }
.s1-row-desc { font-size: 11px; color: var(--s1-t3); margin-top: 2px; line-height: 1.4; }
.s1-row-ctrl { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.s1-row-ctrl-full { flex: 1; flex-shrink: unset; }
.s1-row-ctrl-with-num { gap: 10px; }
.s1-toggle {
  width: 38px; height: 22px; border-radius: 99px; background: var(--s1-brd);
  position: relative; cursor: pointer; transition: background .15s; flex-shrink: 0;
}
.s1-toggle.on { background: var(--s1-ac); }
.s1-toggle-dot {
  width: 16px; height: 16px; border-radius: 50%; background: #fff;
  position: absolute; top: 3px; left: 3px; transition: left .15s;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
}
.s1-toggle.on .s1-toggle-dot { left: 19px; }
.s1-toggle-sm { width: 32px; height: 18px; }
.s1-toggle-sm .s1-toggle-dot { width: 12px; height: 12px; top: 3px; left: 3px; }
.s1-toggle-sm.on .s1-toggle-dot { left: 17px; }
.s1-select {
  padding: 7px 10px; border-radius: 8px; background: var(--s1-bg);
  border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 13px;
  font-family: inherit; outline: none; appearance: none; transition: border-color .15s;
}
.s1-select:focus { border-color: var(--s1-ac); }
.s1-num-wrap { display: flex; align-items: center; gap: 5px; }
.s1-num-prefix { font-size: 12px; color: var(--s1-t3); }
.s1-num-input { width: 70px; padding: 6px 8px; border-radius: 7px; background: var(--s1-bg); border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 13px; font-family: inherit; outline: none; text-align: center; }
.s1-num-wide { width: 90px; }
.s1-num-input:focus { border-color: var(--s1-ac); }
.s1-num-unit { font-size: 11px; color: var(--s1-t3); }
.s1-textarea { width: 100%; padding: 8px 10px; border-radius: 8px; background: var(--s1-bg); border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 12px; font-family: inherit; outline: none; resize: vertical; box-sizing: border-box; }
.s1-textarea:focus { border-color: var(--s1-ac); }
.s1-admin-gate {
  display: flex; align-items: center; gap: 10px;
  padding: 16px; font-size: 12px; color: var(--s1-t3);
}
.s1-admin-gate svg { width: 15px; height: 15px; stroke: var(--s1-t3); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

/* ── NOTIFICATIONS CHECK GROUP ── */
.s1-check-group { display: flex; flex-wrap: wrap; gap: 10px; }
.s1-check-item { display: flex; align-items: center; gap: 6px; cursor: pointer; font-size: 12px; color: var(--s1-t2); }
.s1-check-item input { accent-color: var(--s1-ac); }

/* ── INTEGRATIONS ── */
.s1-integration-block {
  border-bottom: 1px solid var(--s1-brd); padding: 14px 16px;
}
.s1-integration-block:last-of-type { border-bottom: none; }
.s1-int-coming-soon { opacity: .6; }
.s1-int-broken { opacity: .7; }
.s1-int-hdr { display: flex; align-items: center; gap: 12px; }
.s1-int-icon {
  width: 36px; height: 36px; border-radius: 9px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
}
.s1-int-icon svg { width: 16px; height: 16px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-int-icon-voip  { background: rgba(99,102,241,.15);  color: var(--s1-ac); }
.s1-int-icon-email { background: rgba(34,197,94,.15);   color: var(--s1-green); }
.s1-int-icon-sms   { background: rgba(245,158,11,.15);  color: var(--s1-warn); }
.s1-int-icon-wa    { background: rgba(34,197,94,.12);   color: #4ade80; }
.s1-int-icon-google{ background: rgba(59,130,246,.12);  color: #60a5fa; }
.s1-int-info { flex: 1; min-width: 0; }
.s1-int-name { font-size: 13px; font-weight: 700; color: var(--s1-t1); }
.s1-int-status { font-size: 11px; color: var(--s1-t3); margin-top: 2px; }
.s1-int-status.connected { color: var(--s1-green); }
.s1-int-status-broken { color: var(--s1-red) !important; }
.s1-int-fields { padding-top: 12px; display: flex; flex-direction: column; gap: 10px; }
.s1-int-fields .s1-form-row { margin-bottom: 0; }
.s1-coming-soon-badge { padding: 3px 8px; border-radius: 5px; font-size: 10px; font-weight: 700; background: rgba(99,102,241,.15); color: var(--s1-ac); }
.s1-broken-badge { padding: 3px 8px; border-radius: 5px; font-size: 10px; font-weight: 700; background: rgba(239,68,68,.15); color: var(--s1-red); }

/* ── API KEYS ── */
.s1-api-empty { padding: 14px 16px; font-size: 12px; color: var(--s1-t3); }
.s1-api-row { display: flex; align-items: center; justify-content: space-between; padding: 11px 16px; border-bottom: 1px solid var(--s1-brd); gap: 10px; }
.s1-api-key-info { flex: 1; min-width: 0; }
.s1-api-key-name { font-size: 12px; font-weight: 600; color: var(--s1-t1); margin-bottom: 3px; }
.s1-api-key-val { display: flex; align-items: center; gap: 6px; }
.s1-api-masked { font-family: 'SF Mono', monospace; font-size: 11px; color: var(--s1-t3); }
.s1-api-copy { width: 22px; height: 22px; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center; color: var(--s1-t3); transition: color .12s; border-radius: 4px; }
.s1-api-copy:hover { color: var(--s1-ac); }
.s1-api-copy svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.s1-api-meta { font-size: 10px; color: var(--s1-t3); margin-top: 2px; }
.s1-api-revoke {
  padding: 5px 10px; border-radius: 6px; border: 1px solid rgba(239,68,68,.3);
  background: rgba(239,68,68,.08); color: var(--s1-red); font-size: 11px; font-weight: 600;
  cursor: pointer; transition: all .12s; font-family: inherit; flex-shrink: 0;
}
.s1-api-revoke:hover { background: rgba(239,68,68,.18); }
.s1-api-gen-row { display: flex; align-items: center; gap: 8px; padding: 12px 16px; }
.s1-api-name-input { flex: 1; padding: 7px 10px; border-radius: 8px; background: var(--s1-bg); border: 1px solid var(--s1-brd); color: var(--s1-t1); font-size: 12px; font-family: inherit; outline: none; }
.s1-api-name-input:focus { border-color: var(--s1-ac); }
.s1-api-gen-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 13px; border-radius: 8px; border: none;
  background: var(--s1-ac); color: #fff; font-size: 12px; font-weight: 600;
  cursor: pointer; transition: background .15s; font-family: inherit; white-space: nowrap;
}
.s1-api-gen-btn:hover { background: var(--s1-ac-h); }
.s1-api-gen-btn:disabled { opacity: .5; cursor: not-allowed; }
.s1-api-gen-btn svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.s1-key-reveal {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  margin: 4px 16px 12px; padding: 10px 12px; border-radius: 8px;
  background: rgba(34,197,94,.08); border: 1px solid rgba(34,197,94,.25);
  font-size: 11px; color: var(--s1-green);
}
.s1-key-reveal svg { width: 13px; height: 13px; stroke: var(--s1-green); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.s1-key-reveal-val { font-family: 'SF Mono', monospace; font-size: 11px; color: var(--s1-t1); background: var(--s1-bg); padding: 3px 7px; border-radius: 5px; word-break: break-all; }
.s1-key-reveal-copy {
  padding: 4px 10px; border-radius: 5px; border: none;
  background: rgba(34,197,94,.2); color: var(--s1-green); font-size: 11px; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background .12s;
}
.s1-key-reveal-copy:hover { background: rgba(34,197,94,.35); }
.s1-fadein-enter-active { transition: opacity .3s; }
.s1-fadein-enter { opacity: 0; }

/* ── BILLING ── */
.s1-current-plan-card {
  margin: 16px; background: var(--s1-bg); border: 1px solid var(--s1-brd);
  border-radius: 12px; padding: 16px; display: flex; align-items: center; gap: 20px; flex-wrap: wrap;
}
.s1-plan-badge {
  display: inline-block; padding: 5px 12px; border-radius: 8px;
  font-size: 13px; font-weight: 800; letter-spacing: -.2px;
}
.s1-plan-standard  { background: rgba(99,102,241,.15);  color: var(--s1-ac); }
.s1-plan-pro       { background: rgba(168,85,247,.15);  color: #a855f7; }
.s1-plan-unlimited { background: rgba(34,197,94,.15);   color: var(--s1-green); }
.s1-plan-president { background: rgba(245,158,11,.15);  color: var(--s1-warn); }
.s1-plan-detail-grid { display: flex; gap: 24px; flex-wrap: wrap; }
.s1-plan-detail-item { text-align: center; }
.s1-plan-detail-val { font-size: 20px; font-weight: 800; color: var(--s1-t1); line-height: 1; }
.s1-plan-detail-lbl { font-size: 10px; color: var(--s1-t3); margin-top: 3px; text-transform: uppercase; letter-spacing: .4px; }
.s1-plan-remaining { color: var(--s1-ac); }
.s1-plan-remaining.warn { color: var(--s1-red); }
.s1-plan-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 10px; padding: 0 16px 4px; }
.s1-plan-card {
  background: var(--s1-bg); border: 1px solid var(--s1-brd);
  border-radius: 12px; padding: 16px; display: flex; flex-direction: column; gap: 8px;
  transition: border-color .15s;
}
.s1-plan-card.current { border-color: var(--s1-ac); }
.s1-plan-card-president { border-color: rgba(245,158,11,.3); }
.s1-plan-card-name { font-size: 13px; font-weight: 800; color: var(--s1-t1); }
.s1-plan-card-price { font-size: 22px; font-weight: 800; color: var(--s1-t1); letter-spacing: -.5px; }
.s1-plan-mo { font-size: 13px; font-weight: 400; color: var(--s1-t3); }
.s1-plan-card-seats { font-size: 11px; color: var(--s1-t3); }
.s1-plan-features { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 5px; flex: 1; }
.s1-plan-features li { display: flex; align-items: center; gap: 6px; font-size: 11px; color: var(--s1-t2); }
.s1-plan-features li svg { width: 12px; height: 12px; stroke: var(--s1-green); fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.s1-plan-select-btn {
  margin-top: auto; padding: 8px 12px; border-radius: 8px; border: 1px solid var(--s1-brd);
  background: transparent; color: var(--s1-t2); font-size: 12px; font-weight: 600;
  cursor: pointer; transition: all .15s; font-family: inherit;
}
.s1-plan-select-btn:hover:not(:disabled) { background: var(--s1-ac-bg); color: var(--s1-ac); border-color: var(--s1-ac); }
.current-plan-btn { background: var(--s1-ac-bg); color: var(--s1-ac); border-color: var(--s1-ac); cursor: default; }

/* ── LOADING ── */
.s1-loading-row { display: flex; align-items: center; gap: 10px; padding: 20px 16px; color: var(--s1-t3); font-size: 12px; }
.s1-spinner {
  width: 18px; height: 18px; border-radius: 50%;
  border: 2px solid var(--s1-brd); border-top-color: var(--s1-ac);
  animation: s1-spin .7s linear infinite;
}
@keyframes s1-spin { to { transform: rotate(360deg); } }

/* ── DEPOSIT GOAL KPI CARDS ── */
.s1-goal-kpi-val {
  font-size: 36px; font-weight: 900; color: var(--s1-ac); line-height: 1; margin-bottom: 2px; letter-spacing: -1px;
}
.s1-goal-kpi-warn { color: var(--s1-warn); }
.s1-goal-kpi-green { color: var(--s1-green); }
.s1-goal-kpi-lbl { font-size: 10px; color: var(--s1-t3); text-transform: uppercase; letter-spacing: .4px; margin-bottom: 2px; }
.s1-goal-kpi-date { font-size: 10px; color: var(--s1-t3); margin-bottom: 10px; font-style: italic; }
.s1-goal-input-row { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.s1-goal-input-row .s1-goal-input { flex: 1; font-size: 14px; font-weight: 700; }
.s1-goal-save-btn { padding: 6px 14px !important; font-size: 11px !important; white-space: nowrap; flex-shrink: 0; }

/* ── GAMES ACTION BTNS (Grant/Revoke All) ── */
.s1-games-action-btns { display: flex; align-items: center; gap: 4px; justify-content: center; }
.s1-games-grant-btn, .s1-games-revoke-btn {
  display: inline-flex; align-items: center; gap: 3px;
  padding: 3px 8px; border-radius: 5px; border: 1px solid var(--s1-brd);
  background: transparent; font-size: 10px; font-weight: 600; cursor: pointer;
  transition: all .12s; font-family: inherit; white-space: nowrap;
}
.s1-games-grant-btn { color: var(--s1-green); }
.s1-games-grant-btn:hover { background: rgba(34,197,94,.12); border-color: rgba(34,197,94,.4); }
.s1-games-grant-btn svg { width: 10px; height: 10px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.s1-games-revoke-btn { color: var(--s1-red); }
.s1-games-revoke-btn:hover { background: rgba(239,68,68,.12); border-color: rgba(239,68,68,.4); }
.s1-games-revoke-btn svg { width: 10px; height: 10px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }

/* ── LOG SUB-TABS ── */
.s1-log-subtabs {
  display: flex; border-bottom: 1px solid var(--s1-brd); padding: 0; background: var(--s1-surf2);
}
.s1-log-subtab {
  display: flex; align-items: center; gap: 6px;
  padding: 10px 16px; font-size: 12px; font-weight: 600; color: var(--s1-t3);
  cursor: pointer; border-bottom: 2px solid transparent;
  transition: all .15s; white-space: nowrap;
}
.s1-log-subtab:hover { color: var(--s1-t1); background: rgba(0,0,0,.02); }
.s1-log-subtab.active { color: var(--s1-ac); border-bottom-color: var(--s1-ac); }
.s1-log-subtab svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

/* ── LOG PAGINATION ── */
.s1-log-pagination {
  display: flex; align-items: center; justify-content: center; gap: 12px;
  padding: 12px 16px; border-top: 1px solid var(--s1-brd);
}
.s1-log-page-num { font-size: 11px; font-weight: 600; color: var(--s1-t2); }
.s1-log-toolbar-info { font-size: 11px; font-weight: 600; color: var(--s1-t3); margin-right: auto; }
.s1-log-sort-btn { display: inline-flex !important; align-items: center; gap: 4px; }

/* ── Viopa AI section ───────────────────────────────────────── */
.s1-viopa-loading { display: flex; align-items: center; gap: 10px; padding: 20px 0; color: var(--s1-t3); font-size: 13px; }
.s1-viopa-empty { padding: 12px 0; font-size: 13px; color: var(--s1-t3); }
.s1-viopa-key-raw { font-family: monospace; font-size: 10px; opacity: .55; }
.s1-viopa-num { width: 80px; text-align: right; font-family: monospace; }

/* Hide sliding panel — replaced by inline top-strip */
.c1-settings-page .c1-panel { display: none !important; }
</style>
